import {noop} from '@benchling/js-utils';
import $ from 'jquery';
import React from 'react';
import _ from 'underscore';

import * as AlignmentActions from 'analyses/alignment/AlignmentActions';
import {openCreateAlignmentsModalWithIds} from 'analyses/alignment/modals/SharedUtil';
import ProteinAlignmentModal from 'analyses/protein-alignment/ProteinAlignmentModal';
import specifierForProtein from 'analyses/protein-alignment/util/specifierForProtein';
import * as analytics from 'analytics/Analytics';
import * as ArchiveActionsUtil from 'archive/ArchiveActionsUtil';
import ArchiveButton from 'archive/components/buttons/ArchiveButton';
import UnarchiveButton from 'archive/components/buttons/UnarchiveButton';
import isArchivable from 'archive/isArchivable';
import isArchived from 'archive/isArchived';
import {assert} from 'Asserts';
import * as AuditActions from 'audit/AuditActions';
import {
  EXPORT_AUDIT_LOG_DISPLAY_STRING,
  EXPORT_LOCATION_HISTORY_DISPLAY_STRING,
  EXPORT_LOCATION_HISTORY_ERROR_TOOLTIP,
  EXPORT_PLATE_HISTORY_DISPLAY_STRING,
  EXPORT_PLATE_HISTORY_ERROR_TOOLTIP,
  EXPORT_SAMPLE_CONTAINER_HISTORY_DISPLAY_STRING,
} from 'audit/AuditConstants';
import {StandardFeature} from 'auth/capabilities/CapabilityConstants';
import {
  InventoryFeature,
  MolbioFeature,
  ProcessesFeature,
  RegistryFeature,
  V2RequestsFeature,
} from 'auth/capabilities/CapabilityFeatureConstants';
import {areAllFeaturesEnabled, isFeatureEnabled} from 'auth/feature-enablement/FeatureStatus';
import {Permissions} from 'auth/PermissionConstants';
import BenchlingConfig from 'BenchlingConfig';
import {bulkGetValidationExtras} from 'bioentities/BioentityDAO';
import DataConnector from 'connect/DataConnector';
import {
  ACTION_CATEGORY,
  ActionOrigin,
  MODBIO_ANALYTICS_ACTIONS,
  MOLBIO_ANALYTICS_ACTIONS,
} from 'constants/AnalyticsConstants';
import * as ExportConstants from 'constants/ExportConstants';
import * as FileBrowserConstants from 'constants/FileBrowserConstants';
import {StringIDFolder} from 'constants/FolderConstants';
import ModelTypeConstants, {
  COPYABLE_FOLDER_ITEMS,
  EXPORTABLE_FOLDER_ITEMS,
  FOLDER_ITEM_TYPES,
} from 'constants/ModelTypeConstants';
import {REGISTRIES_FINDER_ID} from 'constants/NavConstants';
import {RegistrySummary} from 'constants/RegistryConstants';
import {
  MinimalStorableSummaryWithSchemaId,
  StorableSummary,
  StorableWithPermissions,
} from 'constants/SampleConstants';
import {SampleStatusItemForValidation} from 'constants/SampleStatusConstants';
import {SequenceSummary} from 'constants/SequenceConstants';
import {SourceSummary} from 'constants/SourceConstants';
import * as csrf from 'CSRF';
import ExportActions from 'exports/ExportActions';
import ExportModal from 'exports/ExportModal';
import FileBrowserActions from 'file-browser/FileBrowserActions';
import FinderActions from 'file-browser/FinderActions';
import FileStates from 'FileStates';
import {BioentitySummary, FileSummary, Tag} from 'folder-items/FileConstants';
import * as FileUtil from 'folder-items/FileUtil';
import ExtractByTypename from 'graphql-client/ExtractByTypename';
import {isInaccessible} from 'graphql-client/InaccessibleInfo';
import {overrideValidationStatus} from 'inventory/BioentityActions';
import CICODropdown from 'inventory/check-in-check-out/CICODropdown';
import PrintLabelButton from 'label-printing/PrintLabelButton';
import ApplyModPatternModal, {ApplyModPatternModalProps} from 'modbio/bulk-edit-mods/ApplyModPatternModal';
import {MAX_NUM_BULK_EDIT_MODS_TARGETS} from 'modbio/bulk-edit-mods/BulkEditModsConstants';
import {ManagedModelType} from 'models/ManagedModelDefinitions';
import BulkAttachPrimersModal from 'molbio/BulkAttachPrimersModal';
import * as BulkCodonOptimizationActions from 'molbio/BulkCodonOptimizationActions';
import BulkRemoveFeaturesModal from 'molbio/BulkRemoveFeaturesModal';
import BulkUnlinkPartsModal from 'molbio/BulkUnlinkPartsModal';
import BulkCodonOptimizationModal from 'molbio/codon-optimization/BulkCodonOptimizationModal';
import BatchCRISPRModal from 'molbio/crispr/BatchCRISPRModal';
import BatchExportGuidesModal from 'molbio/crispr/BatchExportGuidesModal';
import {validateSequencesForBulkCodonOptimization} from 'molbio/dao/CodonOptimizationDAO';
import FeatureLibraryModal from 'molbio/feature-libraries/FeatureLibraryModal';
import GenbankExportModal, {GenbankExportPreferences} from 'molbio/GenbankExportModal';
import {
  bulkFindAndReplace,
  getBulkFindAndReplaceTooltipTitle,
  isBulkFindAndReplaceEnabled,
} from 'molbio/monomers/NucleotidesFindAndReplaceUtil';
import {formatOligos} from 'molbio/oligos/ExportOligoUtil';
import ProteinActions from 'molbio/proteins/ProteinActions';
import {ProteinSummary} from 'molbio/proteins/util/ProteinConstants';
import SelectTopologyModal from 'molbio/SelectTopologyModal';
import * as SequenceActions from 'molbio/SequenceActions';
import {trackSubmitAutoFillFeature} from 'molbio/SequenceAnalyticsHelper';
import {ItemListingQuery} from 'nav/sidepanel/listing/__generated/ItemListingQuery';
import BulkUpdateProjectReviewLifecycleModal from 'notebook/reviews/review-lifecycles/BulkUpdateProjectReviewLifecycleModal';
import notifications from 'notifications';
import {
  isFeatureEnabledForProcedureType,
  ProceduresFeature,
} from 'procedures/utils/ProcedureCapabilityManagementHelpers';
import ProcessTaskEditorDropdown from 'processes/dashboard/bulk-edit/ProcessTaskEditorDropdown';
import {
  getProcessItemExecuteTooltipMessage,
  isProcessTaskExecutionAllowed,
} from 'processes/dashboard/ExecuteTasksButton';
import {SidepanelProcessItem} from 'processes/dashboard/ProcessManagementSidepanelConstants';
import * as ProcessManagementActions from 'processes/ProcessManagementActions';
import CreateRequestV2SubmissionShortcutButton from 'processes/requests_v2/shortcuts/CreateRequestV2SubmissionShortcutButton';
import CreateProcessButton from 'processes/tables/create-process-button/CreateProcessButton';
import {
  executeProcessTasksFromSearch,
  getWorksheetUrlFromProcessTask,
  openProcessTaskWithWorksheet,
} from 'processes/util/ProcessTaskExecutionUtil';
import * as AutoFillFieldActions from 'registry/AutoFillFieldActions';
import * as RegistryIdentifierUtilRest from 'registry/RegistryIdentifierUtilRest';
import * as RegistryUtil from 'registry/RegistryUtil';
import CreateRequestFromSamplesButton from 'requests/creation/CreateRequestFromSamplesButton';
import {requestsToCSV} from 'requests/dashboard/requestsToCSV';
import * as InputReduxActions from 'requests/inputs/InputReduxActions';
import {Request} from 'requests/RequestConstants';
import RequestStatusDropdown from 'requests/RequestStatusDropdown';
import {getSampleDetailsForBioentities} from 'requests/SampleGroupUtil';
import TestOrdersEditorDropdown from 'sample-tests/ui/test-orders/TestOrdersEditorDropdown';
import DeleteContainerContentsButton from 'samples/containers/DeleteContainerContentsButton';
import {isFixedPlateWellForNav} from 'samples/SampleUtil';
import * as StorableActions from 'samples/StorableActions';
import {bulkUpdateTagsWithDataMods} from 'samples/StorableActions';
import MoveStorablesButton from 'samples/toolbar/MoveStorablesButton';
import {isFailed} from 'schemas/SchemaValidationChecks';
import TagEditorDropdown from 'schemas/tags/tag-editor/TagEditorDropdown';
import {getTagsToSet} from 'schemas/tags/TagUtil';
import {ListableItem} from 'search/SearchConstants';
import {BulkActionContext, trackBulkActionOnSearchResults} from 'search/searchTracking';
import EntityStore from 'stores/EntityStore';
import refetchStudyTags from 'studies/refetchStudyTags';
import {promptAndGenerateLLMReportFromEntries} from 'studies/report-generation/promptAndGenerateLLMReport';
import AddToStudiesButton from 'studies/studyable/AddToStudiesButton';
import {isItemStudyable} from 'studies/studyable/StudyableUtils';
import {bulkUpdateStudies, BulkUpdateStudiesParam} from 'studies/StudyDAO';
import getTestProps from 'test/lib/cypress/getTestProps';
import * as TrayTaskActions from 'tray/TrayTaskActions';
import * as TrayTaskConstants from 'tray/TrayTaskConstants';
import Tooltip from 'ui-library/bs/Tooltip';
import Button, {ButtonSize, ButtonStyle} from 'ui-library/buttons/Button';
import LegacyDropdownMenu from 'ui-library/dropdowns/LegacyDropdownMenu';
import LegacyDropdownMenuItem from 'ui-library/dropdowns/LegacyDropdownMenuConstants';
import * as LoadingScreen from 'ui-library/LoadingScreen';
import runModal from 'ui-library/runModal';
import licenses from 'user/Licenses';
import APIUtil from 'util/APIUtil';
import * as net from 'util/Net';
import {withLoadingScreen} from 'util/Promises';
import * as ShortcutUtil from 'util/ShortcutUtil';
import * as TaskRunner from 'util/TaskRunner';
import {initiateTextDownload} from 'util/TextToBlobUtil';
import AddToWorklistButton from 'worklists/AddToWorklistButton';
import RemoveFromWorklistButton from 'worklists/RemoveFromWorklistButton';
import * as WorklistUtil from 'worklists/WorklistUtil';

import {SequenceAnalysisSummaryGraphQL} from '../../../../graphql-fragments/molbio/__generated/SequenceAnalysisSummaryGraphQL';
import {CollectibleListingGraphQL} from '../../../../graphql-fragments/notebook/templates/__generated/CollectibleListingGraphQL';
import {ProcessListingGraphQL} from '../../../../graphql-fragments/processes/__generated/ProcessListingGraphQL';
import {ProcessTaskListingGraphQL} from '../../../../graphql-fragments/processes/__generated/ProcessTaskListingGraphQL';
import {TestOrderListingGraphQL} from '../../../../graphql-fragments/sample_tests/__generated/TestOrderListingGraphQL';
import {WorklistSummaryGraphQL} from '../../../../graphql-fragments/worklists/__generated/WorklistSummaryGraphQL';
import CopyButton from './CopyButton';
import DeleteButton from './DeleteButton';
import ExportDropdown from './ExportDropdown';
import MoveButton from './MoveButton';
import RegisterDropdown from './RegisterDropdown';
import SetCollectionModalButton from './SetCollectionModalButton';
import UnregisterButton from './UnregisterButton';

type SidepanelProcessTask = ExtractByTypename<ItemListingQuery['processTasks'][number], 'ProcessTaskNode'>;

interface Props {
  actionOrigin: ActionOrigin;
  finderId: string;
  folder?: StringIDFolder | null;
  folderId?: string | null;
  selectedIds: Array<string>;
  items: Array<ListableItem>;
  collection?: string | null;
  onRefreshResults: () => void;
  onSaveOrder?: ((orderedItemIds: Array<String>) => void) | null;
  worklistSummary?: WorklistSummaryGraphQL | null;
  // This prop is for analytics purpose only. It is undefined by default.
  context?: BulkActionContext;
  /** Search session id, passed down from item listing to allow refreshing specific search session. Useful
   * for search views like study items that rely on an item id rather than just the section. */
  searchSessionId?: string;
}

enum ActionKey {
  // General
  ARCHIVE = 'ARCHIVE',
  BULK_EXPORT_FOLDER_ITEMS = 'BULK_EXPORT_FOLDER_ITEMS',
  CHECK_IN_CHECK_OUT = 'CHECK_IN_CHECK_OUT',
  DELETE = 'DELETE',
  EXPORT_AUDIT_LOGS = 'EXPORT_AUDIT_LOGS',
  EXPORT_MENU = 'EXPORT_MENU',
  EXPORT_LOCATION_HISTORY_REPORT = 'EXPORT_LOCATION_HISTORY_REPORT',
  EXPORT_PLATE_HISTORY_REPORT = 'EXPORT_PLATE_HISTORY_REPORT',
  EXPORT_SAMPLE_CONTAINER_HISTORY_REPORT = 'EXPORT_SAMPLE_CONTAINER_HISTORY_REPORT',
  UNARCHIVE = 'UNARCHIVE',
  SAVE_ORDER = 'SAVE_ORDER',
  CREATE_PROCESS = 'CREATE_PROCESS',
  CREATE_REQUEST_V2 = 'CREATE_REQUEST_V2',

  // Folder items
  APPLY_MOD_PATTERN = 'APPLY_MOD_PATTERN',
  ATTACH_PRIMERS = 'ATTACH_PRIMERS',
  AUTO_ANNOTATE = 'AUTO_ANNOTATE',
  AUTOFILL_PARTS = 'AUTOFILL_PARTS',
  AUTOFILL_TRANSLATIONS = 'AUTOFILL_TRANSLATIONS',
  AUTOFILL_TRANSCRIPTIONS = 'AUTOFILL_TRANSCRIPTIONS',
  BACK_TRANSLATE = 'BACK_TRANSLATE',
  BATCH_CRISPR_DESIGN = 'BATCH_CRISPR_DESIGN',
  CHANGE_REVIEW_PROCESS = 'CHANGE_REVIEW_PROCESS',
  CODON_OPTIMIZE = 'CODON_OPTIMIZE',
  COPY = 'COPY',
  COPY_OLIGOS = 'COPY_OLIGOS',
  COPY_REGISTRY_IDENTIFIERS = 'COPY_REGISTRY_IDENTIFIERS',
  CREATE_SEQUENCE_ALIGNMENT = 'CREATE_SEQUENCE_ALIGNMENT',
  CREATE_PROTEIN_ALIGNMENT = 'CREATE_PROTEIN_ALIGNMENT',
  DETACH_PRIMERS = 'DETACH_PRIMERS',
  EDIT = 'EDIT',
  EXPORT_ALIGNMENT_SOURCE_FILES = 'EXPORT_ALIGNMENT_SOURCE_FILES',
  EXPORT_FOLDER_ITEMS_TO_CSV = 'EXPORT_FOLDER_ITEMS_TO_CSV',
  EXPORT_MOLECULES = 'EXPORT_MOLECULES',
  EXPORT_SEQUENCES = 'EXPORT_SEQUENCES',
  EXPORT_PROTEINS = 'EXPORT_PROTEINS',
  EXPORT_ZIP = 'EXPORT_ZIP',
  FIND_AND_REPLACE_NUCLEOTIDES = 'FIND_AND_REPLACE_NUCLEOTIDES',
  GENERATE_REPORT_FROM_ENTRIES = 'GENERATE_REPORT_FROM_ENTRIES',
  MOVE = 'MOVE',
  OPEN_FILE = 'OPEN_FILE',
  OVERRIDE_VALIDATION = 'OVERRIDE_VALIDATION',
  REGISTER = 'REGISTER',
  REMOVE_ANNOTATIONS = 'REMOVE_ANNOTATIONS',
  REMOVE_TRANSLATIONS = 'REMOVE_TRANSLATIONS',
  SET_COLLECTION = 'SET_COLLECTION',
  SET_TOPOLOGY = 'SET_TOPOLOGY',
  UNLINK_PARTS = 'UNLINK_PARTS',
  UNREGISTER = 'UNREGISTER',

  // Batches
  COPY_BATCH_IDS = 'COPY_BATCH_IDS',

  // Label Printing
  PRINT_LABELS = 'PRINT_LABELS',

  // Storables
  DELETE_CONTAINER_CONTENTS = 'DELETE_CONTAINER_CONTENTS',
  COPY_BARCODES = 'COPY_BARCODES',
  EXPORT_CONTAINERS_TO_CSV = 'EXPORT_CONTAINERS_TO_CSV',
  MOVE_STORABLES = 'MOVE_STORABLES',

  // Requests
  CREATE_REQUEST_FROM_BIOENTITIES = 'CREATE_REQUEST_FROM_BIOENTITIES',
  CREATE_REQUEST_FROM_CONTAINERS = 'CREATE_REQUEST_FROM_CONTAINERS',
  EXPORT_REQUESTS_TO_CSV = 'EXPORT_REQUESTS_TO_CSV',
  UPDATE_REQUEST_STATUS = 'UPDATE_REQUEST_STATUS',

  // Worklists
  ADD_TO_WORKLIST = 'ADD_TO_WORKLIST',
  REMOVE_FROM_WORKLIST = 'REMOVE_FROM_WORKLIST',

  // Processes
  EXPORT_PROCESSES_TO_CSV = 'EXPORT_PROCESSES_TO_CSV',
  EXPORT_PROCESS_TASKS_TO_CSV = 'EXPORT_PROCESS_TASKS_TO_CSV',
  EXECUTE_PROCESS_TASKS = 'EXECUTE_PROCESS_TASKS',

  // Studyables
  ADD_TO_STUDIES = 'ADD_TO_STUDIES',
}

interface ActionOptions {
  finderId: string;
  folder?: StringIDFolder | null;
  isRegistry: boolean;
}

interface ActionConfiguration {
  key: ActionKey;
  isEnabled: (item: ListableItem, options: ActionOptions) => boolean;
  isAllEnabled?: (item: Array<ListableItem>, options: ActionOptions) => boolean;
  getTooltipTitle?: (item: Array<ListableItem>, options: ActionOptions) => string;
}

interface Action {
  key: ActionKey;
  disabled: boolean;
  selectedItems: Array<ListableItem>;
  selectedIds: Array<string>;
  tooltipTitle?: string;
}

const isRegistered = (item: BioentitySummary): boolean =>
  item.folder != null && RegistryUtil.isRegistered(item);

const getPartialFeatureDefinition = (
  item: BioentitySummary
): {item: BioentitySummary; itemState: {isRegistered: boolean}} => ({
  item,
  itemState: {
    isRegistered: isRegistered(item),
  },
});

export const isProject = (item: ListableItem): boolean => {
  if (!APIUtil.isFolder(item.id)) {
    return false;
  }
  const folder = item as StringIDFolder;
  return folder.parent == null && folder.source?.sourceType === ModelTypeConstants.PROJECT;
};

export const mapRootFolderToProject = (item: ListableItem): ListableItem | SourceSummary =>
  isProject(item) ? (item as StringIDFolder).source! : item;

const isEditSequenceEnabled = (item: ListableItem): boolean =>
  APIUtil.apiIdToType(item.id) === ModelTypeConstants.SEQUENCE &&
  !FileUtil.isOligo(item) &&
  isFeatureEnabled({feature: MolbioFeature.MOLBIO_EDIT});

function isProcedureCollectibleItem(
  item: ListableItem | SourceSummary
): item is ExtractByTypename<CollectibleListingGraphQL, 'ProcedureNode'> {
  return APIUtil.apiIdToType(item.id) === ModelTypeConstants.PROCEDURE;
}

function isArchiveOrUnarchiveFeatureEnabledForListableItem(
  item: ListableItem | SourceSummary,
  feature: StandardFeature.ARCHIVE | StandardFeature.UNARCHIVE
): boolean {
  // TODO(BNCH-124744): Ideally, we wouldn't need to check if the ListableItem was a Procedure and we could
  // just use the standard feature definition.
  if (isProcedureCollectibleItem(item)) {
    return isFeatureEnabledForProcedureType(
      item.procedureType,
      feature === StandardFeature.ARCHIVE ? ProceduresFeature.ARCHIVE : ProceduresFeature.UNARCHIVE
    );
  }
  return isFeatureEnabled({
    feature,
    ...getPartialFeatureDefinition(item as unknown as BioentitySummary),
  });
}

function isArchiveFeatureEnabledForListableItem(item: ListableItem | SourceSummary): boolean {
  return isArchiveOrUnarchiveFeatureEnabledForListableItem(item, StandardFeature.ARCHIVE);
}

function isUnarchiveFeatureEnabledForListableItem(item: ListableItem | SourceSummary): boolean {
  return isArchiveOrUnarchiveFeatureEnabledForListableItem(item, StandardFeature.UNARCHIVE);
}

function itemSupportsEditableAnnotations(item: ListableItem): boolean {
  return (
    [ModelTypeConstants.SEQUENCE, ModelTypeConstants.PROTEIN].includes(APIUtil.apiIdToType(item.id)) &&
    isFeatureEnabled({feature: MolbioFeature.MOLBIO_EDIT})
  );
}

interface EnhancedProps {
  folder: StringIDFolder | null;
  onBulkUpdateRequests: (requestIds: Array<string>, data: object) => void;
}

class ExpandedToolbarConnector extends DataConnector<Props, EnhancedProps> {
  enhanceProps(): EnhancedProps {
    const folder = this.props.folderId
      ? this.getOrFetchOptional(ManagedModelType.FOLDER_BY_ID, this.props.folderId)
      : null;
    return {
      folder: this.props.folder || (folder ? {...folder, id: folder.api_identifier} : null),
      onBulkUpdateRequests: async (requestIds: Array<string>, data: object) => {
        await this.dispatch(InputReduxActions.bulkUpdateRequests(requestIds, data));
      },
    };
  }
}

export class ExpandedToolbar extends React.Component<Props & EnhancedProps> {
  getActionOrigin = (): ActionOrigin => {
    switch (this.props.actionOrigin) {
      case ActionOrigin.SEARCH_SIDEPANEL:
        return ActionOrigin.SEARCH_EXPANDED_SEARCH_TOOLBAR;
      case ActionOrigin.REGISTRY_EXPANDED_SEARCH:
        return ActionOrigin.REGISTRY_EXPANDED_SEARCH_TOOLBAR;
      case ActionOrigin.INSIGHTS_SIDEPANEL:
        return ActionOrigin.INSIGHTS_EXPANDED_SEARCH_TOOLBAR;
      default:
        return this.props.actionOrigin;
    }
  };

  getSelectedItems = (): Array<ListableItem> =>
    this.props.items.filter((item) => this.props.selectedIds.includes(item.id));

  getSelectedItemIndices = (): Array<number> =>
    this.props.items.reduce((selectedIndices: Array<number>, item: ListableItem, index: number) => {
      if (this.props.selectedIds.includes(item.id)) {
        selectedIndices.push(index);
      }
      return selectedIndices;
    }, []);

  getSelectedItemIdsForWorklist = (): Array<string> => {
    const {selectedIds, items} = this.props;

    const testOrderIds = selectedIds.filter((id) => APIUtil.isTestOrder(id));
    const nonTestOrderIds = selectedIds.filter((id) => !APIUtil.isTestOrder(id));
    if (!BenchlingConfig.SAMPLE_TESTS_ENABLE) {
      return nonTestOrderIds;
    }

    const selectedTestOrders = items.filter((item): item is ListableItem & TestOrderListingGraphQL =>
      testOrderIds.includes(item.id)
    );
    const linkedContainerIdsFromSelectedTestOrders = selectedTestOrders.reduce(
      (containerIds: Array<string>, testOrder) => {
        if (testOrder.container != null && !isInaccessible(testOrder.container)) {
          containerIds.push(testOrder?.container.id);
        }
        return containerIds;
      },
      []
    );
    const deduplicatedIds = new Set([...nonTestOrderIds, ...linkedContainerIdsFromSelectedTestOrders]);
    return [...deduplicatedIds];
  };

  /**
   * Processes can accept bioentities or storables as inputs. Here, we also parse test orders and extract the
   * containers that are linked from them, so that they can also be used as inputs to the process. Containers
   * that are selected directly and those that are linked from selected test orders are deduplicated.
   */
  getSelectedItemsForTaskCreationShortcuts = (
    selectedIds: Array<string>,
    selectedItems: Array<ListableItem>
  ): Array<BioentitySummary> | Array<MinimalStorableSummaryWithSchemaId> => {
    const testOrderIds = selectedIds.filter((id) => APIUtil.isTestOrder(id));
    if (!BenchlingConfig.SAMPLE_TESTS_ENABLE) {
      return selectedItems as Array<BioentitySummary> | Array<MinimalStorableSummaryWithSchemaId>;
    }

    const nonTestOrderIds = selectedIds.filter((id) => !APIUtil.isTestOrder(id));
    const nonTestOrderItems = selectedItems.filter((item) => !APIUtil.isTestOrder(item.id));
    const selectedTestOrders = selectedItems.filter((item): item is ListableItem & TestOrderListingGraphQL =>
      testOrderIds.includes(item.id)
    );
    const linkedContainersFromSelectedTestOrders = selectedTestOrders.reduce(
      (containers: Array<MinimalStorableSummaryWithSchemaId>, testOrder) => {
        if (
          testOrder.container != null &&
          !isInaccessible(testOrder.container) &&
          !nonTestOrderIds.includes(testOrder.container.id)
        ) {
          // Downstream code in CreateProcessButton needs id, name, and storableSchema id
          containers.push({
            id: testOrder.container.id,
            name: testOrder.container.name,
            storableSchema: {id: testOrder.container.storableSchema.id},
          });
        }
        return containers;
      },
      []
    );

    return [...nonTestOrderItems, ...linkedContainersFromSelectedTestOrders] as
      | Array<BioentitySummary>
      | Array<MinimalStorableSummaryWithSchemaId>;
  };

  /**
   * The bulk action tracking is manually injected into each button and dropdown menu items
   * from this component. It is easier to manage the tracking in one place, than doing that
   * separately in 20+ different buttons and dropdowns. This is not the most ideal implementation,
   * and should be merged into a unified "toolbar button interface" in the future when this
   * entire toolbar is refactored.
   */
  trackBulkAction = (actionName: string, actionCategory: ACTION_CATEGORY): void => {
    trackBulkActionOnSearchResults(
      actionName,
      this.getSelectedItemIndices(),
      actionCategory,
      ...(this.props.context != null ? [this.props.context] : [])
    );
  };

  getOligosClipboardValue = (): string => {
    const selectedItems = this.getSelectedItems() as Array<BioentitySummary> as Array<
      SequenceSummary & {bases: string}
    >;
    const selectedOligos = selectedItems.filter(
      (item) => item.sequence_type === FileBrowserConstants.SEQUENCE_TYPE.OLIGO
    );
    const oligosToExport = selectedOligos.map((item) => ({
      name: item.name,
      bases: item.bases,
      nucleotideType: item.nucleotideType,
      // @ts-expect-error
      description: item.notePreview,
      tags: item.tags,
    }));
    return formatOligos(oligosToExport, 'tsv');
  };

  handleCreateSequenceAlignment = (): void => {
    const sequenceIds = this.props.selectedIds;
    LoadingScreen.show();
    openCreateAlignmentsModalWithIds(sequenceIds).always(() => {
      LoadingScreen.hide();
    });
  };

  handleCreateProteinAlignment = (): void => {
    ProteinAlignmentModal.open({
      initialProteinSpecifiers: this.getSelectedItems().map((protein) =>
        specifierForProtein(protein as ProteinSummary & {permissions: Permissions})
      ),
    });
  };

  handleOpenBatchCRISPR = async (): Promise<void> => {
    this.trackBulkAction('BatchCRISPR', ACTION_CATEGORY.WRITE);
    await runModal(BatchCRISPRModal, {
      sequences: this.getSelectedItems(),
    });
  };

  handleOpenExportGuides = async (): Promise<void> => {
    this.trackBulkAction('ExportGuides', ACTION_CATEGORY.READ);
    await runModal(BatchExportGuidesModal, {
      sequences: this.getSelectedItems(),
    });
  };

  handleExportContainersToCSV = (): void => {
    this.trackBulkAction('ExportContainersToCSV', ACTION_CATEGORY.READ);
    StorableActions.exportContainersToCSV(this.props.selectedIds);
  };

  handleExportAuditLogs = (): void => {
    this.trackBulkAction('ExportAuditLogs', ACTION_CATEGORY.READ);
    const selectedIds = this.getSelectedItems().map((item) => mapRootFolderToProject(item).id);
    AuditActions.exportAuditLogs(selectedIds);
  };

  handleExportSampleContainerHistoryReport = (): void => {
    this.trackBulkAction('ExportSampleContainerHistoryReport', ACTION_CATEGORY.READ);
    const selectedIds = this.getSelectedItems().map((item: ListableItem) => item.id);
    AuditActions.exportSampleContainerHistory(selectedIds);
  };

  handleExportPlateHistoryReport = (): void => {
    this.trackBulkAction('ExportPlateHistoryReport', ACTION_CATEGORY.READ);
    const selectedIds = this.getSelectedItems().map((item: ListableItem) => item.id);
    AuditActions.exportPlateHistoryReport(selectedIds);
  };

  handleExportLocationHistoryReport = (): void => {
    this.trackBulkAction('ExportLocationHistoryReport', ACTION_CATEGORY.READ);
    const selectedIds = this.getSelectedItems().map((item: ListableItem) => item.id);
    AuditActions.exportLocationHistoryReport(selectedIds);
  };

  handleExportAll = (): void => {
    if (this.props.folder) {
      ExportModal.openForFolder(this.props.folder);
    } else {
      ExportModal.open();
    }
  };

  handleBulkExportFiles = (): void => {
    this.trackBulkAction('ExportSelectedItems', ACTION_CATEGORY.READ);
    ExportActions.requestBulkExportFiles(
      this.props.selectedIds,
      ExportConstants.TYPE.BULK,
      ExportConstants.FORMAT.BULK_ZIP_PDF
    );
  };

  handleExportFilesToCSV = (): void => {
    this.trackBulkAction('ExportFilesToCSV', ACTION_CATEGORY.READ);
    FileBrowserActions.exportTagsToCSV(this.props.selectedIds);
  };

  handleExportRequestsToCSV = (): void => {
    this.trackBulkAction('ExportRequestsToCSV', ACTION_CATEGORY.READ);
    initiateTextDownload(requestsToCSV(this.getSelectedItems() as Array<Request>), 'requests.csv');
  };

  handleExportBioentity = async (format: string, exportURL: string = 'export'): Promise<void> => {
    const ids = this.props.selectedIds;
    const urlParams = $.param({dl: true, format});
    const $form = $('<form>').attr({
      action: `/${exportURL}?${urlParams}`,
      method: 'POST',
      target: '_blank',
    });
    $form.append(
      $('<input>').attr({
        type: 'hidden',
        name: 'csrf_token',
        value: csrf.token,
      })
    );
    $form.append(
      $('<input>').attr({
        type: 'hidden',
        name: 'ids',
        value: ids.join('-'),
      })
    );
    if (format === 'gb') {
      const exportPreferences: GenbankExportPreferences | null = await runModal(GenbankExportModal, {});
      if (exportPreferences == null) {
        return;
      }
      $form.append(
        $('<input>').attr({
          type: 'hidden',
          name: 'exportColors',
          value: exportPreferences.exportAnnotationColors,
        })
      );
      $form.append(
        $('<input>').attr({
          type: 'hidden',
          name: 'restrictFeatType',
          value: exportPreferences.convertNonStandardAnnotations,
        })
      );
    }
    $form.hide().appendTo('body').submit().remove();
  };

  handleExportGenBank = async (): Promise<void> => {
    this.trackBulkAction('ExportToGenBank', ACTION_CATEGORY.READ);
    await this.handleExportBioentity('gb');
  };

  handleExportFasta = async (): Promise<void> => {
    this.trackBulkAction('ExportToFasta', ACTION_CATEGORY.READ);
    await this.handleExportBioentity('fasta');
  };

  handleProteinExportFasta = async (): Promise<void> => {
    this.trackBulkAction('ExportProteinToFasta', ACTION_CATEGORY.READ);
    await this.handleExportBioentity('fasta', 'export-proteins');
  };

  handleExportCsv = async (): Promise<void> => {
    this.trackBulkAction('ExportToCSV', ACTION_CATEGORY.READ);
    await this.handleExportBioentity('csv');
  };

  handleExportZip = async (): Promise<void> => {
    this.trackBulkAction('ExportToZip', ACTION_CATEGORY.READ);
    await this.handleExportBioentity('zip', 'export-zip');
  };

  handleBackTranslate = async (): Promise<void> => {
    this.trackBulkAction('BackTranslate', ACTION_CATEGORY.WRITE);
    analytics.deprecatedTrackEvent(MOLBIO_ANALYTICS_ACTIONS.OPENED_BULK_BACK_TRANSLATION, {
      numProteins: this.props.selectedIds.length,
    });
    const results = await runModal(BulkCodonOptimizationModal, {
      isBackTranslation: true,
      valid: true,
      errors: [],
    });
    if (!results) {
      return;
    }
    await BulkCodonOptimizationActions.bulkBackTranslateOrCodonOptimize(
      this.props.selectedIds,
      results,
      true
    );
  };

  handleApplyModPattern = async (): Promise<void> => {
    this.trackBulkAction('ApplyModificationPattern', ACTION_CATEGORY.WRITE);
    const nucleotideTypes = new Set(
      this.getSelectedItems().map((item) => (item as SequenceSummary).nucleotideType)
    );
    assert(
      nucleotideTypes.size === 1,
      'Modification patterns can only be applied to oligos of the same nucleotide type'
    );
    analytics.trackEvent(MODBIO_ANALYTICS_ACTIONS.OPENED_MOD_PATTERN_MODAL, {
      actionOrigin: this.getActionOrigin(),
    });
    await runModal<ApplyModPatternModalProps>(ApplyModPatternModal, {
      targetOligoIds: this.props.selectedIds,
      nucleotideType: Array.from(nucleotideTypes)[0],
      shouldSkipResultsScreenAfterSuccess: false,
      isBulk: true,
    });
  };

  handleFindAndReplaceNucleotides = (): void => {
    this.trackBulkAction('FindAndReplaceNucleotides', ACTION_CATEGORY.WRITE);
    const selectedSequences = this.getSelectedItems().map((item) => item as SequenceSummary);
    bulkFindAndReplace(this.props.selectedIds, selectedSequences, this.getActionOrigin());
  };

  handleCodonOptimize = async (): Promise<void> => {
    this.trackBulkAction('CodonOptimization', ACTION_CATEGORY.WRITE);
    analytics.deprecatedTrackEvent(MOLBIO_ANALYTICS_ACTIONS.OPENED_BULK_CODON_OPTIMIZATION, {
      numSequences: this.props.selectedIds.length,
    });
    const validationResult = await validateSequencesForBulkCodonOptimization(this.props.selectedIds);
    const results = await runModal(BulkCodonOptimizationModal, {
      isBackTranslation: false,
      valid: validationResult.valid,
      errors: validationResult.errors,
    });
    if (!results) {
      return;
    }
    await BulkCodonOptimizationActions.bulkBackTranslateOrCodonOptimize(
      this.props.selectedIds,
      results,
      false
    );
  };

  handleExportAlignmentSourceFiles = async (): Promise<void> => {
    this.trackBulkAction('ExportAlignmentSourceFiles', ACTION_CATEGORY.READ);
    await AlignmentActions.exportSourceFiles(this.props.selectedIds);
  };

  handleExportSdf = async (): Promise<void> => {
    this.trackBulkAction('ExportMoleculesToSdf', ACTION_CATEGORY.READ);
    await this.handleExportBioentity('sdf', 'export-molecules');
  };

  getExportMenuItems = (actionsByKey: {
    [actionKey: string]: Action;
  }): Array<Array<LegacyDropdownMenuItem>> => {
    const isRegistry = this.props.finderId === REGISTRIES_FINDER_ID;
    return [
      _.compact([
        {
          name: 'Export all items',
          handleOnClick: this.handleExportAll,
          dataTestAttrs: {component: 'ExpandedToolbar', element: 'exportAllItems'},
          visible: BenchlingConfig.ENABLE_EXPORTS,
        },
        actionsByKey[ActionKey.BULK_EXPORT_FOLDER_ITEMS] && {
          name: 'Export selected items',
          handleOnClick: this.handleBulkExportFiles,
          disabled: actionsByKey[ActionKey.BULK_EXPORT_FOLDER_ITEMS].disabled,
          visible: BenchlingConfig.ENABLE_EXPORTS,
        },
        actionsByKey[ActionKey.EXPORT_AUDIT_LOGS] && {
          name: EXPORT_AUDIT_LOG_DISPLAY_STRING,
          handleOnClick: this.handleExportAuditLogs,
          disabled: actionsByKey[ActionKey.EXPORT_AUDIT_LOGS].disabled,
          dataTestAttrs: {component: 'ExpandedToolbar', element: 'exportAuditLogs'},
        },
        actionsByKey[ActionKey.EXPORT_PLATE_HISTORY_REPORT] && {
          name: EXPORT_PLATE_HISTORY_DISPLAY_STRING,
          handleOnClick: this.handleExportPlateHistoryReport,
          disabled: actionsByKey[ActionKey.EXPORT_PLATE_HISTORY_REPORT].disabled,
          dataTestAttrs: {component: 'ExpandedToolbar', element: 'exportPlateHistoryReport'},
          tooltipText: actionsByKey[ActionKey.EXPORT_PLATE_HISTORY_REPORT].tooltipTitle,
        },
        actionsByKey[ActionKey.EXPORT_SAMPLE_CONTAINER_HISTORY_REPORT] && {
          name: EXPORT_SAMPLE_CONTAINER_HISTORY_DISPLAY_STRING,
          handleOnClick: this.handleExportSampleContainerHistoryReport,
          disabled: actionsByKey[ActionKey.EXPORT_SAMPLE_CONTAINER_HISTORY_REPORT].disabled,
          dataTestAttrs: {component: 'ExpandedToolbar', element: 'exportSampleContainerHistoryReport'},
          tooltipText: actionsByKey[ActionKey.EXPORT_SAMPLE_CONTAINER_HISTORY_REPORT].tooltipTitle,
        },
        actionsByKey[ActionKey.EXPORT_LOCATION_HISTORY_REPORT] && {
          name: EXPORT_LOCATION_HISTORY_DISPLAY_STRING,
          handleOnClick: this.handleExportLocationHistoryReport,
          disabled: actionsByKey[ActionKey.EXPORT_LOCATION_HISTORY_REPORT].disabled,
          dataTestAttrs: {component: 'ExpandedToolbar', element: 'exportLocationHistoryReport'},
          tooltipText: actionsByKey[ActionKey.EXPORT_LOCATION_HISTORY_REPORT].tooltipTitle,
        },
      ]),
      _.compact([
        actionsByKey[ActionKey.EXPORT_CONTAINERS_TO_CSV] && {
          name: 'Export containers to CSV',
          handleOnClick: this.handleExportContainersToCSV,
          disabled: actionsByKey[ActionKey.EXPORT_CONTAINERS_TO_CSV].disabled,
          tooltipText: actionsByKey[ActionKey.EXPORT_CONTAINERS_TO_CSV].disabled
            ? 'Please select containers'
            : undefined,
          visible: BenchlingConfig.ENABLE_EXPORTS,
        },
        actionsByKey[ActionKey.EXPORT_PROCESSES_TO_CSV] &&
          isFeatureEnabled({feature: ProcessesFeature.PROCESSES_EXPORT}) && {
            name: 'Export workflow task groups to CSV',
            handleOnClick: async () => {
              this.trackBulkAction('ExportWorkflowTaskGroupsToCSV', ACTION_CATEGORY.READ);
              await ProcessManagementActions.exportToCSV(
                ModelTypeConstants.PROCESS,
                actionsByKey[ActionKey.EXPORT_PROCESSES_TO_CSV].selectedIds
              );
            },
            disabled: actionsByKey[ActionKey.EXPORT_PROCESSES_TO_CSV].disabled,
            tooltipText: actionsByKey[ActionKey.EXPORT_PROCESSES_TO_CSV].disabled
              ? 'Please select task groups'
              : undefined,
            visible: BenchlingConfig.ENABLE_EXPORTS,
          },
        actionsByKey[ActionKey.EXPORT_PROCESS_TASKS_TO_CSV] &&
          isFeatureEnabled({feature: ProcessesFeature.PROCESSES_EXPORT}) && {
            name: 'Export workflow tasks to CSV',
            handleOnClick: async () => {
              this.trackBulkAction('ExportWorkflowTasksToCSV', ACTION_CATEGORY.READ);
              await ProcessManagementActions.exportToCSV(
                ModelTypeConstants.PROCESS_TASK,
                actionsByKey[ActionKey.EXPORT_PROCESS_TASKS_TO_CSV].selectedIds
              );
            },
            disabled: actionsByKey[ActionKey.EXPORT_PROCESS_TASKS_TO_CSV].disabled,
            tooltipText: actionsByKey[ActionKey.EXPORT_PROCESS_TASKS_TO_CSV].disabled
              ? 'Please select workflow tasks'
              : undefined,
            visible: BenchlingConfig.ENABLE_EXPORTS,
          },
        actionsByKey[ActionKey.COPY_BARCODES] && {
          name: 'Copy barcodes',
          handleOnClick: (): void => {
            this.trackBulkAction('CopyBarcodes', ACTION_CATEGORY.READ);
          },
          clipboardData: this.getSelectedItems()
            .map((storable) => (storable as StorableSummary).barcode)
            .join('\n'),
          disabled: actionsByKey[ActionKey.COPY_BARCODES].disabled,
        },
      ]),
      _.compact([
        actionsByKey[ActionKey.EXPORT_FOLDER_ITEMS_TO_CSV] && {
          name: 'Export files to CSV',
          handleOnClick: this.handleExportFilesToCSV,
          disabled: actionsByKey[ActionKey.EXPORT_FOLDER_ITEMS_TO_CSV].disabled,
          dataTestAttrs: {
            component: 'ExpandedToolbar',
            element: 'exportMenuItem',
            key: ActionKey.EXPORT_FOLDER_ITEMS_TO_CSV,
          },
          visible: BenchlingConfig.ENABLE_EXPORTS,
        },
        actionsByKey[ActionKey.EXPORT_REQUESTS_TO_CSV] && {
          name: 'Export requests to CSV',
          handleOnClick: this.handleExportRequestsToCSV,
          disabled: actionsByKey[ActionKey.EXPORT_REQUESTS_TO_CSV].disabled,
          visible: BenchlingConfig.ENABLE_EXPORTS,
        },
        {
          name: 'Copy names',
          handleOnClick: (): void => {
            this.trackBulkAction('CopyNames', ACTION_CATEGORY.READ);
          },
          clipboardData: this.getSelectedItems()
            .map((item) => item.name)
            .join('\n'),
          visible: this.props.selectedIds.length > 0,
        },
        isRegistry &&
          actionsByKey[ActionKey.COPY_REGISTRY_IDENTIFIERS] && {
            name: 'Copy registry IDs',
            handleOnClick: (): void => {
              this.trackBulkAction('CopyRegistryIDs', ACTION_CATEGORY.READ);
            },
            clipboardData: this.getSelectedItems()
              .map((file) =>
                RegistryIdentifierUtilRest.getRegistryIdentifier(
                  (file as BioentitySummary).bioentityAliasInfos,
                  this.props.collection
                )
              )
              .join('\n'),
            disabled: actionsByKey[ActionKey.COPY_REGISTRY_IDENTIFIERS].disabled,
          },
        actionsByKey[ActionKey.COPY_BATCH_IDS] && {
          name: 'Copy batch IDs',
          handleOnClick: (): void => {
            this.trackBulkAction('CopyBatchIDs', ACTION_CATEGORY.READ);
          },
          clipboardData: this.getSelectedItems()
            .map((item) => item.name)
            .join('\n'),
        },
      ]),
      _.compact([
        actionsByKey[ActionKey.EXPORT_SEQUENCES] && {
          name: 'Multipart GenBank',
          handleOnClick: this.handleExportGenBank,
          disabled: actionsByKey[ActionKey.EXPORT_SEQUENCES].disabled,
          dataTestAttrs: {
            component: 'ExpandedToolbar',
            element: 'exportMenuItem',
            key: 'exportGenBank',
          },
          visible: BenchlingConfig.ENABLE_EXPORTS,
        },
        actionsByKey[ActionKey.EXPORT_SEQUENCES] && {
          name: 'Nucleotide sequence multi-FASTA',
          handleOnClick: this.handleExportFasta,
          disabled: actionsByKey[ActionKey.EXPORT_SEQUENCES].disabled,
          dataTestAttrs: {
            component: 'ExpandedToolbar',
            element: 'exportMenuItem',
            key: 'exportFASTA',
          },
          visible: BenchlingConfig.ENABLE_EXPORTS,
        },
        actionsByKey[ActionKey.EXPORT_PROTEINS] && {
          name: 'AA sequence multi-FASTA',
          handleOnClick: this.handleProteinExportFasta,
          disabled: actionsByKey[ActionKey.EXPORT_PROTEINS].disabled,
          dataTestAttrs: {
            component: 'ExpandedToolbar',
            element: 'exportMenuItem',
            key: 'exportAASequenceFASTA',
          },
          visible: BenchlingConfig.ENABLE_EXPORTS,
        },
        actionsByKey[ActionKey.EXPORT_SEQUENCES] && {
          name: 'CSV',
          handleOnClick: this.handleExportCsv,
          disabled: actionsByKey[ActionKey.EXPORT_SEQUENCES].disabled,
          visible: BenchlingConfig.ENABLE_EXPORTS,
        },
        actionsByKey[ActionKey.EXPORT_ZIP] && {
          name: 'Zip archive',
          handleOnClick: this.handleExportZip,
          disabled: actionsByKey[ActionKey.EXPORT_ZIP].disabled,
          visible: BenchlingConfig.ENABLE_EXPORTS,
        },
        actionsByKey[ActionKey.COPY_OLIGOS] && {
          name: 'Copy to clipboard',
          handleOnClick: (): void => {
            this.trackBulkAction('CopyToClipboard', ACTION_CATEGORY.READ);
          },
          clipboardData: this.getOligosClipboardValue(),
          disabled: actionsByKey[ActionKey.COPY_OLIGOS].disabled,
        },
        actionsByKey[ActionKey.EXPORT_ALIGNMENT_SOURCE_FILES] && {
          name: 'Alignment source files',
          handleOnClick: this.handleExportAlignmentSourceFiles,
          disabled: actionsByKey[ActionKey.EXPORT_ALIGNMENT_SOURCE_FILES].disabled,
          visible: BenchlingConfig.ENABLE_EXPORTS,
        },
        actionsByKey[ActionKey.EXPORT_MOLECULES] && {
          name: 'SDF',
          handleOnClick: this.handleExportSdf,
          disabled: actionsByKey[ActionKey.EXPORT_MOLECULES].disabled,
          visible: BenchlingConfig.ENABLE_EXPORTS,
        },
      ]),
    ];
  };

  handleOpenWorkspaceItems = (): void => {
    this.trackBulkAction('OpenWorkspaceItems', ACTION_CATEGORY.READ);
    FileBrowserActions.openMultipleItems(this.getSelectedItems());
  };

  handleGenerateLLMReportFromEntries = async (): Promise<void> => {
    this.trackBulkAction('GenerateReportFromEntries', ACTION_CATEGORY.WRITE);
    const newEntryId = await promptAndGenerateLLMReportFromEntries(
      this.getSelectedItems().map((item) => item.id)
    );
    if (newEntryId) {
      FileBrowserActions.openItem(newEntryId);
    }
  };

  handleAutoFillPartFields = async (): Promise<void> => {
    this.trackBulkAction('AutoFillPartFields', ACTION_CATEGORY.WRITE);
    const items = this.getSelectedItems();
    // For now, just check if the items have a tag schema at all. Ideally, we would also check if there's an
    // eligible part link field on each schema and present the error in a friendlier way.
    if (items.some((item) => !item.tagSchema)) {
      notifications.error('Cannot autofill parts fields on entities without a schema set.');
      return;
    }
    const itemIds = items.map((item) => item.id);
    trackSubmitAutoFillFeature(itemIds, this.getActionOrigin(), 'Parts');
    await AutoFillFieldActions.bulkAutoFillPartFields(itemIds);
  };

  handleUnlinkParts = async (): Promise<void> => {
    this.trackBulkAction('UnlinkParts', ACTION_CATEGORY.WRITE);
    const items = this.getSelectedItems();
    if (items.some((item) => !item.tagSchema)) {
      notifications.error('All selected sequences must have a schema.');
      return;
    }
    const tagSchema = items[0].tagSchema!;
    if (!items.every((item) => item.tagSchema && item.tagSchema.id === tagSchema.id)) {
      notifications.error('All selected sequences must have the same schema.');
      return;
    }

    const [sequenceToParts, validationExtras] = await withLoadingScreen(
      Promise.all([
        net.postJSONPromise({
          url: '/1/api/sequence-parts',
          data: {
            sequenceIds: this.props.selectedIds,
          },
        }),
        bulkGetValidationExtras(this.props.selectedIds),
      ])
    );

    const bulkUnlinkResult = await runModal(BulkUnlinkPartsModal, {
      sequenceToParts,
      sequences: items,
      validationExtrasBySequenceId: validationExtras.validationExtrasByBioentityId,
      tagSchema,
    });
    if (!bulkUnlinkResult) {
      return;
    }
    const trayTaskId = TrayTaskActions.createTrayTask({
      heading: 'Unlinking parts',
      progress: TrayTaskConstants.INDETERMINATE_PROGRESS,
    });
    try {
      await TaskRunner.postJSONPromise({
        url: '/1/api/unlink-parts',
        data: {
          unlinkSpecs: bulkUnlinkResult.unlinkSpecs,
        },
      });
    } catch (e) {
      // Our top-level handler will show an appropriate error message, so just hide the current tray task.
      TrayTaskActions.removeTrayTask(trayTaskId);
      throw e;
    }
    this.props.onRefreshResults();
    TrayTaskActions.updateTrayTask(trayTaskId, {
      progress: TrayTaskConstants.SUCCESS_PROGRESS,
      heading: 'Unlinked parts',
    });
  };

  handleAutoFillTranslations = async (): Promise<void> => {
    this.trackBulkAction('AutoFillTranslations', ACTION_CATEGORY.WRITE);
    const items = this.getSelectedItems();
    // For now, just check if the items have a tag schema at all. Ideally, we would also check if there's an
    // eligible translation link field on each schema and present the error in a friendlier way.
    if (items.some((item) => !item.tagSchema)) {
      notifications.error('Cannot autofill translations on bioentities without a schema set.');
      return;
    }
    const itemIds = items.map((item) => item.id);
    trackSubmitAutoFillFeature(itemIds, this.getActionOrigin(), 'Translations');
    await AutoFillFieldActions.bulkAutofillTranslations(itemIds);
  };

  handleAutoFillTranscriptions = async (): Promise<void> => {
    this.trackBulkAction('AutoFillTranscriptions', ACTION_CATEGORY.WRITE);
    const items = this.getSelectedItems();
    // For now, just check if the items have a tag schema at all. Ideally, we would also check if there's an
    // eligible transcription link field on each schema and present the error in a friendlier way.
    if (items.some((item) => !item.tagSchema)) {
      notifications.error('Cannot autofill transcriptions on bioentities without a schema set.');
      return;
    }
    const itemIds = items.map((item) => item.id);
    trackSubmitAutoFillFeature(itemIds, this.getActionOrigin(), 'Transcriptions');
    await AutoFillFieldActions.bulkAutofillTranscriptions(itemIds);
  };

  handleAutoAnnotate = async (): Promise<void> => {
    this.trackBulkAction('AutoAnnotate', ACTION_CATEGORY.WRITE);
    const featureLibraryIds = await runModal(FeatureLibraryModal, {});
    if (!featureLibraryIds) {
      return;
    }

    if (APIUtil.apiIdToType(this.props.selectedIds[0]) === ModelTypeConstants.SEQUENCE) {
      SequenceActions.batchAutoAnnotate(this.props.selectedIds, featureLibraryIds);
    } else {
      await ProteinActions.bulkAutoAnnotate(this.props.selectedIds, featureLibraryIds);
    }
  };

  handleAttachPrimers = async (): Promise<void> => {
    this.trackBulkAction('AttachPrimers', ACTION_CATEGORY.WRITE);
    const attachPrimersOptions = await runModal(BulkAttachPrimersModal, {});
    if (!attachPrimersOptions) {
      return;
    }

    await SequenceActions.bulkAttachPrimers(this.props.selectedIds, attachPrimersOptions);
  };

  handleSetTopology = async (): Promise<void> => {
    this.trackBulkAction('SetTopology', ACTION_CATEGORY.WRITE);
    const topology = await runModal(SelectTopologyModal, {});
    if (!topology) {
      return;
    }
    await SequenceActions.bulkUpdateSequenceTopology(this.props.selectedIds, topology);
  };

  handleValidationOverride = async (): Promise<void> => {
    this.trackBulkAction('OverrideValidationChecks', ACTION_CATEGORY.WRITE);
    await overrideValidationStatus(this.props.selectedIds);
    this.props.onRefreshResults();
  };

  handleSaveOrder = (): void => {
    this.trackBulkAction('SaveOrder', ACTION_CATEGORY.WRITE);
    this.props.onSaveOrder!(this.props.items.map((item) => item.id));
  };

  handleDetachPrimers = async (): Promise<void> => {
    this.trackBulkAction('DetachPrimers', ACTION_CATEGORY.WRITE);
    const doDetachPrimers = await runModal(BulkRemoveFeaturesModal, {feature: 'primer'});
    if (!doDetachPrimers) {
      return;
    }
    await SequenceActions.bulkDetachPrimers(this.props.selectedIds);
  };

  handleRemoveAnnotations = async (): Promise<void> => {
    this.trackBulkAction('RemoveAnnotations', ACTION_CATEGORY.WRITE);
    const doRemoveAnnotations = await runModal(BulkRemoveFeaturesModal, {feature: 'annotation'});
    if (!doRemoveAnnotations) {
      return;
    }
    // There could be both proteins and sequences selected, so we kick off both ProteinActions.bulkRemoveAnnotations
    // and/or SequenceActions.bulkRemoveAnnotations for the appropriate entity IDs.
    const proteinIds = this.props.selectedIds.filter(
      (selectedId) => APIUtil.apiIdToType(selectedId) === ModelTypeConstants.PROTEIN
    );
    const sequenceIds = this.props.selectedIds.filter(
      (selectedId) => APIUtil.apiIdToType(selectedId) === ModelTypeConstants.SEQUENCE
    );
    if (proteinIds.length > 0) {
      await ProteinActions.bulkRemoveAnnotations(proteinIds);
    }
    if (sequenceIds.length > 0) {
      await SequenceActions.bulkRemoveAnnotations(sequenceIds);
    }
  };

  handleRemoveTranslations = async (): Promise<void> => {
    this.trackBulkAction('RemoveTranslation', ACTION_CATEGORY.WRITE);
    const doRemoveTranslations = await runModal(BulkRemoveFeaturesModal, {feature: 'translation'});
    if (!doRemoveTranslations) {
      return;
    }
    await SequenceActions.bulkRemoveTranslations(this.props.selectedIds);
  };

  handleChangeReviewProcess = async (): Promise<void> => {
    this.trackBulkAction('ChangeReviewProcess', ACTION_CATEGORY.WRITE);
    const selectedIds = this.getSelectedItems().map((item: ListableItem) => mapRootFolderToProject(item).id);
    await runModal(BulkUpdateProjectReviewLifecycleModal, {projectIds: selectedIds});
  };

  getMoreMenuItems = (actionsByKey: {[actionKey: string]: Action}): Array<Array<LegacyDropdownMenuItem>> =>
    _.compact([
      actionsByKey[ActionKey.OPEN_FILE] && [
        {
          name: 'Open',
          icon: 'open',
          handleOnClick: this.handleOpenWorkspaceItems,
          disabled: actionsByKey[ActionKey.OPEN_FILE].disabled,
        },
      ],
      actionsByKey[ActionKey.GENERATE_REPORT_FROM_ENTRIES] && [
        {
          name: 'Generate report',
          icon: 'file',
          handleOnClick: this.handleGenerateLLMReportFromEntries,
          disabled: actionsByKey[ActionKey.GENERATE_REPORT_FROM_ENTRIES].disabled,
        },
      ],
      actionsByKey[ActionKey.CHANGE_REVIEW_PROCESS] && [
        {
          name: 'Change review process',
          icon: 'review_lifecycles',
          handleOnClick: this.handleChangeReviewProcess,
          disabled: actionsByKey[ActionKey.CHANGE_REVIEW_PROCESS].disabled,
        },
      ],
      actionsByKey[ActionKey.EXECUTE_PROCESS_TASKS] && [
        {
          name: 'Execute',
          icon: 'process-task',
          handleOnClick: async () => {
            const executableTasks = this.getSelectedItems() as Array<SidepanelProcessTask>;
            if (executableTasks.length === 1 && getWorksheetUrlFromProcessTask(executableTasks[0])) {
              openProcessTaskWithWorksheet(executableTasks[0], this.getActionOrigin());
            } else {
              this.trackBulkAction('ExecuteTask', ACTION_CATEGORY.WRITE);
              await executeProcessTasksFromSearch(executableTasks, undefined, this.getActionOrigin());
            }
          },
          disabled:
            actionsByKey[ActionKey.EXECUTE_PROCESS_TASKS].disabled ||
            !isProcessTaskExecutionAllowed(this.getSelectedItems() as Array<SidepanelProcessItem>),
          tooltipText:
            getProcessItemExecuteTooltipMessage(
              this.getSelectedItems() as Array<SidepanelProcessItem>,
              true
            ) ?? undefined,
        },
      ],
      this.props.onSaveOrder && [
        {
          name: 'Save Order',
          icon: 'arrow-down',
          handleOnClick: this.handleSaveOrder,
          // actionsByKey[SAVE_ORDER] is null when there are no items listed => the option should be disabled
          disabled: actionsByKey[ActionKey.SAVE_ORDER] == null,
        },
      ],
      [
        {
          name: 'Analyze',
          icon: 'analyze',
          dropLeft: true,
          visible: [
            ActionKey.CREATE_SEQUENCE_ALIGNMENT,
            ActionKey.CREATE_PROTEIN_ALIGNMENT,
            ActionKey.AUTO_ANNOTATE,
            ActionKey.AUTOFILL_PARTS,
            ActionKey.UNLINK_PARTS,
            ActionKey.AUTOFILL_TRANSLATIONS,
            ActionKey.AUTOFILL_TRANSCRIPTIONS,
            ActionKey.BATCH_CRISPR_DESIGN,
            ActionKey.BACK_TRANSLATE,
          ].some((actionKey) => Object.keys(actionsByKey).includes(actionKey)),
          submenu: [
            _.compact([
              actionsByKey[ActionKey.CREATE_SEQUENCE_ALIGNMENT] && {
                name: 'Create DNA / RNA Alignment',
                handleOnClick: () => {
                  this.trackBulkAction('CreateSequenceAlignment', ACTION_CATEGORY.WRITE);
                  this.handleCreateSequenceAlignment();
                },
                disabled: actionsByKey[ActionKey.CREATE_SEQUENCE_ALIGNMENT].disabled,
              },
              actionsByKey[ActionKey.CREATE_PROTEIN_ALIGNMENT] && {
                name: 'Create AA Alignment',
                handleOnClick: () => {
                  this.trackBulkAction('CreateProteinAlignment', ACTION_CATEGORY.WRITE);
                  this.handleCreateProteinAlignment();
                },
                disabled: actionsByKey[ActionKey.CREATE_PROTEIN_ALIGNMENT].disabled,
              },
            ]),
            _.compact([
              actionsByKey[ActionKey.AUTO_ANNOTATE] && {
                name: 'Auto-Annotate',
                handleOnClick: this.handleAutoAnnotate,
                disabled:
                  actionsByKey[ActionKey.AUTO_ANNOTATE].disabled ||
                  new Set(
                    actionsByKey[ActionKey.AUTO_ANNOTATE].selectedItems.map((item) =>
                      APIUtil.apiIdToMaybeType(item.id)
                    )
                  ).size > 1,
              },
              actionsByKey[ActionKey.ATTACH_PRIMERS] && {
                name: 'Attach Primers',
                handleOnClick: this.handleAttachPrimers,
                disabled: actionsByKey[ActionKey.ATTACH_PRIMERS].disabled,
              },
              actionsByKey[ActionKey.AUTOFILL_PARTS] && {
                name: 'Autofill part fields',
                handleOnClick: this.handleAutoFillPartFields,
                disabled: actionsByKey[ActionKey.AUTOFILL_PARTS].disabled,
              },
              actionsByKey[ActionKey.AUTOFILL_TRANSLATIONS] && {
                name: 'Autofill translations',
                handleOnClick: this.handleAutoFillTranslations,
                disabled: actionsByKey[ActionKey.AUTOFILL_TRANSLATIONS].disabled,
              },
              actionsByKey[ActionKey.AUTOFILL_TRANSCRIPTIONS] && {
                name: 'Autofill transcriptions',
                handleOnClick: this.handleAutoFillTranscriptions,
                disabled: actionsByKey[ActionKey.AUTOFILL_TRANSCRIPTIONS].disabled,
              },
              actionsByKey[ActionKey.SET_TOPOLOGY] && {
                name: 'Set topology',
                disabled: actionsByKey[ActionKey.SET_TOPOLOGY].disabled,
                handleOnClick: this.handleSetTopology,
              },
              actionsByKey[ActionKey.CODON_OPTIMIZE] && {
                name: 'Codon optimize',
                handleOnClick: this.handleCodonOptimize,
                disabled: actionsByKey[ActionKey.CODON_OPTIMIZE].disabled,
                dataTestAttrs: {
                  component: 'ExpandedToolbar',
                  element: 'analyzeSubMenuItem',
                },
              },
            ]),
            _.compact([
              actionsByKey[ActionKey.REMOVE_ANNOTATIONS] && {
                name: 'Remove annotations',
                handleOnClick: this.handleRemoveAnnotations,
                disabled: actionsByKey[ActionKey.REMOVE_ANNOTATIONS].disabled,
              },
              actionsByKey[ActionKey.DETACH_PRIMERS] && {
                name: 'Detach primers',
                handleOnClick: this.handleDetachPrimers,
                disabled: actionsByKey[ActionKey.DETACH_PRIMERS].disabled,
              },
              actionsByKey[ActionKey.UNLINK_PARTS] && {
                name: 'Unlink parts',
                handleOnClick: this.handleUnlinkParts,
                disabled: actionsByKey[ActionKey.UNLINK_PARTS].disabled,
              },
              actionsByKey[ActionKey.REMOVE_TRANSLATIONS] && {
                name: 'Remove translations',
                handleOnClick: this.handleRemoveTranslations,
                disabled: actionsByKey[ActionKey.REMOVE_TRANSLATIONS].disabled,
              },
            ]),
            _.compact([
              actionsByKey[ActionKey.BATCH_CRISPR_DESIGN] && {
                name: 'Run CRISPR analyses',
                handleOnClick: this.handleOpenBatchCRISPR,
                disabled: actionsByKey[ActionKey.BATCH_CRISPR_DESIGN].disabled,
              },
              actionsByKey[ActionKey.BATCH_CRISPR_DESIGN] && {
                name: 'Export guides',
                handleOnClick: this.handleOpenExportGuides,
                disabled: actionsByKey[ActionKey.BATCH_CRISPR_DESIGN].disabled,
              },
            ]),
            _.compact([
              actionsByKey[ActionKey.BACK_TRANSLATE] && {
                name: 'Back translate',
                handleOnClick: this.handleBackTranslate,
                disabled: actionsByKey[ActionKey.BACK_TRANSLATE].disabled,
              },
            ]),
          ],
          dataTestAttrs: {
            component: 'ExpandedToolbar',
            element: 'getMoreMenuItem',
          },
        },
        {
          name: 'Bulk edit',
          icon: 'bulk-edit',
          dropLeft: true,
          visible: [ActionKey.APPLY_MOD_PATTERN, ActionKey.FIND_AND_REPLACE_NUCLEOTIDES].some((actionKey) =>
            Object.keys(actionsByKey).includes(actionKey)
          ),
          submenu: [
            _.compact([
              actionsByKey[ActionKey.APPLY_MOD_PATTERN] && {
                name: 'Apply modification pattern',
                handleOnClick: this.handleApplyModPattern,
                disabled: actionsByKey[ActionKey.APPLY_MOD_PATTERN].disabled,
                tooltipText: actionsByKey[ActionKey.APPLY_MOD_PATTERN].tooltipTitle,
                dataTestAttrs: {
                  component: 'ExpandedToolbar',
                  element: 'applyModPatternSubmenuItem',
                },
              },
              actionsByKey[ActionKey.FIND_AND_REPLACE_NUCLEOTIDES] && {
                name: 'Find and replace nucleotides',
                handleOnClick: this.handleFindAndReplaceNucleotides,
                disabled: actionsByKey[ActionKey.FIND_AND_REPLACE_NUCLEOTIDES].disabled,
                tooltipText: actionsByKey[ActionKey.FIND_AND_REPLACE_NUCLEOTIDES].tooltipTitle,
                dataTestAttrs: {
                  component: 'ExpandedToolbar',
                  element: 'findAndReplaceNucleotidesSubmenuItem',
                },
              },
            ]),
          ],
          dataTestAttrs: {
            component: 'ExpandedToolbar',
            element: 'bulkEditMenuItem',
          },
        },
      ],
      [
        {
          name: 'Refresh',
          icon: 'refresh',
          handleOnClick: () => {
            this.trackBulkAction('Refresh', ACTION_CATEGORY.READ);
            this.props.onRefreshResults();
          },
        },
      ],
      _.compact([
        actionsByKey[ActionKey.OVERRIDE_VALIDATION] && {
          name: 'Override validation checks',
          icon: 'override-validation',
          disabled: actionsByKey[ActionKey.OVERRIDE_VALIDATION].disabled,
          handleOnClick: this.handleValidationOverride,
        },
      ]),
    ]);

  makeBulkEditSubmitCallback =
    (selectedItems: Array<ListableItem>): ((newTag: Tag, selectedStorableIds: Array<string>) => void) =>
    async (newTag: Tag, selectedStorableIds: Array<string>): Promise<void> => {
      const tagsToSet = getTagsToSet([newTag]);
      if (APIUtil.isStorable(selectedItems[0].id)) {
        // Some selected storables may have been de-selected in TagEditorModal due to status warnings
        // So only update the selectedStorableIds from the callback
        await bulkUpdateTagsWithDataMods(selectedStorableIds, tagsToSet);
      } else if (APIUtil.isStudy(selectedItems[0].id)) {
        const itemIds: Array<string> = selectedItems.map((result) => result.id);
        const paramsList: BulkUpdateStudiesParam = {updates: []};
        for (const id of itemIds) {
          paramsList.updates.push({id, tags: tagsToSet});
        }
        await bulkUpdateStudies(paramsList);
        await refetchStudyTags(itemIds);
      } else {
        const itemIds = selectedItems.map((result) => result.id);
        const hasRegisteredItems = !selectedItems.every((item) => !isRegistered(item as BioentitySummary));

        FinderActions.updateTagsWithFinderWithDataMods(this.props.finderId, itemIds, hasRegisteredItems, {
          toSet: tagsToSet,
          toAdd: [],
          toRemove: [],
          toRename: {},
        });
      }
    };

  getEditorDropdown(editAction: Action, selectedItems: Array<ListableItem>): JSX.Element {
    // Keep in sync with item types that have special dropdowns below & are not supported by TagEditorDropdown
    const itemHasAlternateDropdownEditor = (item: ListableItem): boolean => APIUtil.isTestOrder(item.id);
    if (selectedItems.length > 0) {
      if (selectedItems.every((item) => APIUtil.isProcessTask(item.id))) {
        return (
          <ProcessTaskEditorDropdown
            items={editAction.selectedItems as Array<ProcessTaskListingGraphQL>}
            onClickTracking={(selectedItemName: string) => {
              this.trackBulkAction(`ProcessTask-${selectedItemName}`, ACTION_CATEGORY.WRITE);
            }}
          />
        );
      } else if (selectedItems.length !== 0 && selectedItems.every((item) => APIUtil.isTestOrder(item.id))) {
        return (
          <TestOrdersEditorDropdown items={selectedItems} searchSessionId={this.props.searchSessionId} />
        );
      }
    }
    return (
      <TagEditorDropdown
        finderId={this.props.finderId}
        results={selectedItems}
        onSubmit={this.makeBulkEditSubmitCallback(editAction.selectedItems)}
        buttonStyle={ButtonStyle.TERTIARY_WHITE}
        actionOrigin={this.getActionOrigin()}
        onClickTracking={(itemName) => {
          this.trackBulkAction(`EditTag-${itemName}`, ACTION_CATEGORY.WRITE);
        }}
        itemHasAlternateEditor={itemHasAlternateDropdownEditor}
      />
    );
  }

  override render(): JSX.Element | null {
    const isSignedIn = EntityStore.currentUser() != null;
    if (!isSignedIn) {
      return null;
    }
    const selectedItems = this.getSelectedItems();
    const options = {
      isRegistry: this.props.finderId === REGISTRIES_FINDER_ID,
      folder: this.props.folder,
      finderId: this.props.finderId,
    };
    let initialSelectedFolderId: string | undefined;
    if (selectedItems.some((item) => FileUtil.isInRegistry(item))) {
      // @ts-expect-error
      initialSelectedFolderId = ShortcutUtil.findCommonProjectFolderId(selectedItems) ?? undefined;
    } else if (this.props.folder && !RegistryUtil.isRegistry(this.props.folder.source)) {
      initialSelectedFolderId = this.props.folder.id;
    } else if (selectedItems.some((item) => APIUtil.isProcess(item.id))) {
      initialSelectedFolderId = (
        selectedItems.find((item) => APIUtil.isProcess(item.id)) as ProcessListingGraphQL
      ).folder.id;
    }

    const actionConfigurations: Array<ActionConfiguration> = [
      {
        key: ActionKey.ARCHIVE,
        isEnabled: (item: ListableItem): boolean =>
          isArchivable(item) &&
          !isArchived(item) &&
          isArchiveFeatureEnabledForListableItem(item) &&
          !APIUtil.isRun(item.id), // TODO(BNCH-66165): Enable archiving runs via the ExpandedToolbar
        isAllEnabled: (items: Array<ListableItem>): boolean =>
          ArchiveActionsUtil.getArchiveActionInfoFromModelTypes(
            items.map((item) => APIUtil.apiIdToType(mapRootFolderToProject(item).id))
          ) != null,
      },
      {
        key: ActionKey.BULK_EXPORT_FOLDER_ITEMS,
        isEnabled: (item: ListableItem): boolean =>
          BenchlingConfig.ENABLE_EXPORTS &&
          EXPORTABLE_FOLDER_ITEMS.includes(APIUtil.apiIdToType(item.id)) &&
          isFeatureEnabled({
            feature: StandardFeature.EXPORT,
            ...getPartialFeatureDefinition(item as BioentitySummary),
          }),
      },
      {
        key: ActionKey.DELETE,
        isEnabled: (item: ListableItem): boolean => {
          // worksheets are not deletable
          if (APIUtil.isWorksheet(item.id)) {
            return false;
          }
          return (
            BenchlingConfig.ENABLE_DELETE &&
            isFeatureEnabled({
              feature: StandardFeature.DELETE,
              ...getPartialFeatureDefinition(item as BioentitySummary),
            })
          );
        },
      },
      {
        key: ActionKey.EXPORT_AUDIT_LOGS,
        isEnabled: (item: ListableItem): boolean =>
          licenses.hasCommercialLicense() &&
          (APIUtil.isFolderItem(item.id) ||
            APIUtil.isBatch(item.id) ||
            APIUtil.isStorable(item.id) ||
            APIUtil.isProcessTask(item.id) ||
            APIUtil.isConnection(item.id) ||
            APIUtil.isFolder(item.id) ||
            APIUtil.isTemplateCollectible(item.id) ||
            APIUtil.isTemplateCollection(item.id) ||
            APIUtil.isRequestV2Submission(item.id) ||
            APIUtil.isWorklist(item.id) ||
            isProject(item)),
      },
      {
        key: ActionKey.EXPORT_PLATE_HISTORY_REPORT,
        isEnabled: (item: ListableItem): boolean => licenses.hasEnterprisePlan() && APIUtil.isPlate(item.id),
        isAllEnabled: (items: Array<ListableItem>): boolean => {
          const selectedPlates = items.filter((item) => APIUtil.isPlate(item.id));
          return selectedPlates.length === 1 && items.length === 1;
        },
        getTooltipTitle: (items: Array<ListableItem>): string => {
          const selectedPlates = items.filter((item) => APIUtil.isPlate(item.id));
          return selectedPlates.length !== 1 || items.length !== 1 ? EXPORT_PLATE_HISTORY_ERROR_TOOLTIP : '';
        },
      },
      {
        key: ActionKey.EXPORT_SAMPLE_CONTAINER_HISTORY_REPORT,
        isEnabled: (item: ListableItem): boolean =>
          licenses.hasEnterprisePlan() && APIUtil.isContainer(item.id),
        isAllEnabled: (items: Array<ListableItem>): boolean =>
          items.length <= BenchlingConfig.AUDITING_MAX_NUM_SAMPLE_CONTAINER_HISTORY_REPORT_PER_EXPORT,
        getTooltipTitle: (items: Array<ListableItem>): string => {
          const selectedContainers = items.filter((item) => APIUtil.isContainer(item.id));
          const numSelectedContainers = selectedContainers.length;
          const maxNumContainersPerExport =
            BenchlingConfig.AUDITING_MAX_NUM_SAMPLE_CONTAINER_HISTORY_REPORT_PER_EXPORT;

          if (items.length !== numSelectedContainers) {
            return 'Reports can only be exported for containers.';
          }

          if (numSelectedContainers > maxNumContainersPerExport) {
            return `Please select at most ${maxNumContainersPerExport} containers (${numSelectedContainers} selected).`;
          }
          return '';
        },
      },
      {
        key: ActionKey.EXPORT_LOCATION_HISTORY_REPORT,
        isEnabled: (item: ListableItem): boolean =>
          licenses.hasEnterprisePlan() && APIUtil.isLocation(item.id),
        getTooltipTitle: (items: Array<ListableItem>): string => {
          if (items.length === 0) {
            return 'Please select one or more locations.';
          }

          const allLocations = items.filter((item) => APIUtil.isLocation(item.id));
          const numLocations = allLocations.length;
          return numLocations === 0 || items.length !== numLocations
            ? EXPORT_LOCATION_HISTORY_ERROR_TOOLTIP
            : '';
        },
      },
      {
        key: ActionKey.EXPORT_MENU,
        isEnabled: (item: ListableItem): boolean =>
          !APIUtil.isAnalyticsDashboard(item.id) &&
          !APIUtil.isTemplateCollection(item.id) &&
          !APIUtil.isTemplateCollectible(item.id),
      },
      {
        key: ActionKey.UNARCHIVE,
        isEnabled: (item: ListableItem): boolean => {
          const archivableItem = mapRootFolderToProject(item);
          return (
            isArchivable(archivableItem) &&
            isArchived(archivableItem) &&
            isUnarchiveFeatureEnabledForListableItem(archivableItem)
          );
        },
        isAllEnabled: (items: Array<ListableItem>): boolean =>
          ArchiveActionsUtil.getArchiveActionInfoFromModelTypes(
            items.map((item) => APIUtil.apiIdToType(mapRootFolderToProject(item).id))
          ) != null,
      },
      {
        key: ActionKey.AUTO_ANNOTATE,
        isEnabled: (item: ListableItem): boolean => itemSupportsEditableAnnotations(item),
      },
      {
        key: ActionKey.REMOVE_ANNOTATIONS,
        isEnabled: (item: ListableItem): boolean => itemSupportsEditableAnnotations(item),
      },
      {
        key: ActionKey.REMOVE_TRANSLATIONS,
        isEnabled: (item: ListableItem): boolean => isEditSequenceEnabled(item),
      },
      {
        key: ActionKey.ATTACH_PRIMERS,
        isEnabled: (item: ListableItem): boolean => isEditSequenceEnabled(item),
      },
      {
        key: ActionKey.DETACH_PRIMERS,
        isEnabled: (item: ListableItem): boolean => isEditSequenceEnabled(item),
      },
      {
        key: ActionKey.AUTOFILL_PARTS,
        isEnabled: (item: ListableItem): boolean => isEditSequenceEnabled(item),
      },
      {
        key: ActionKey.UNLINK_PARTS,
        isEnabled: (item: ListableItem): boolean =>
          APIUtil.apiIdToType(item.id) === ModelTypeConstants.SEQUENCE &&
          areAllFeaturesEnabled([
            {feature: MolbioFeature.MOLBIO_EDIT},
            {feature: RegistryFeature.REGISTRY_EDIT},
          ]),
      },
      {
        key: ActionKey.AUTOFILL_TRANSLATIONS,
        isEnabled: (item: ListableItem): boolean => isEditSequenceEnabled(item),
      },
      {
        key: ActionKey.AUTOFILL_TRANSCRIPTIONS,
        isEnabled: (item: ListableItem): boolean =>
          isEditSequenceEnabled(item) &&
          FileUtil.isDnaSequence(item) &&
          // Only show autofill transcriptions if users have registry access
          isFeatureEnabled({feature: RegistryFeature.REGISTRY_EDIT}),
      },
      {
        key: ActionKey.BACK_TRANSLATE,
        isEnabled: (item: ListableItem): boolean =>
          APIUtil.apiIdToType(item.id) === ModelTypeConstants.PROTEIN &&
          BenchlingConfig.MOLBIO_ENABLE_BULK_BACK_TRANSLATION &&
          isFeatureEnabled({feature: MolbioFeature.MOLBIO_EDIT}),
      },
      {
        key: ActionKey.BATCH_CRISPR_DESIGN,
        isEnabled: (item: ListableItem): boolean =>
          APIUtil.apiIdToType(item.id) === ModelTypeConstants.SEQUENCE &&
          BenchlingConfig.ENABLE_BATCH_GUIDE_DESIGN &&
          FileUtil.isDnaSequence(item) &&
          isFeatureEnabled({feature: MolbioFeature.MOLBIO_EDIT}),
      },
      {
        key: ActionKey.CHANGE_REVIEW_PROCESS,
        isEnabled: (item: ListableItem): boolean =>
          BenchlingConfig.ENABLE_ENTRY_REVIEW_PROCESSES && isProject(item) && Boolean(item.permissions.admin),
      },
      {
        key: ActionKey.CHECK_IN_CHECK_OUT,
        isEnabled: (item: ListableItem): boolean => APIUtil.isContainer(item.id),
      },
      {
        key: ActionKey.CODON_OPTIMIZE,
        isEnabled: (item: ListableItem): boolean =>
          APIUtil.apiIdToType(item.id) === ModelTypeConstants.SEQUENCE &&
          BenchlingConfig.MOLBIO_ENABLE_BULK_BACK_TRANSLATION &&
          !FileUtil.isOligo(item) &&
          !FileUtil.isRnaSequence(item) &&
          isFeatureEnabled({feature: MolbioFeature.MOLBIO_EDIT}),
      },
      {
        key: ActionKey.COPY,
        isEnabled: (item: ListableItem): boolean =>
          (COPYABLE_FOLDER_ITEMS.includes(APIUtil.apiIdToType(item.id)) ||
            (APIUtil.isFolder(item.id) && (item as StringIDFolder).parent != null)) &&
          isFeatureEnabled({item, feature: StandardFeature.CREATE}),
      },
      {
        key: ActionKey.COPY_OLIGOS,
        isEnabled: (item: ListableItem): boolean =>
          APIUtil.apiIdToType(item.id) === ModelTypeConstants.SEQUENCE &&
          (item as BioentitySummary as SequenceSummary).type === FileBrowserConstants.SEQUENCE_TYPE.OLIGO &&
          isFeatureEnabled({item, feature: StandardFeature.CREATE}),
      },
      {
        key: ActionKey.COPY_REGISTRY_IDENTIFIERS,
        isEnabled: (item: ListableItem): boolean =>
          APIUtil.isBiologicalEntity(item.id) && FileUtil.isInRegistry(item),
      },
      {
        key: ActionKey.CREATE_SEQUENCE_ALIGNMENT,
        isEnabled: (item: ListableItem): boolean =>
          APIUtil.apiIdToType(item.id) === ModelTypeConstants.SEQUENCE &&
          !FileUtil.isOligo(item) &&
          isFeatureEnabled({feature: MolbioFeature.MOLBIO_CREATE}),
      },
      {
        key: ActionKey.CREATE_PROTEIN_ALIGNMENT,
        isEnabled: (item: ListableItem): boolean =>
          APIUtil.apiIdToType(item.id) === ModelTypeConstants.PROTEIN &&
          isFeatureEnabled({feature: MolbioFeature.MOLBIO_CREATE}),
      },
      {
        key: ActionKey.EDIT,
        isEnabled: (item: ListableItem): boolean => {
          if (item.permissions.hasOwnProperty('tagsEditable')) {
            if (
              !isFeatureEnabled({
                feature: StandardFeature.EDIT_TAGS,
                ...getPartialFeatureDefinition(item as BioentitySummary),
              })
            ) {
              return false;
            }
          } else if (APIUtil.isTestOrder(item.id)) {
            // TODO(BNCH-111425): Consider whether test orders should be controlled via capability management
            // or have write intent. Test orders have neither right now, so this case must be checked
            // separately rather than relying on isFeatureEnabled.
            return true;
          } else if (
            !isFeatureEnabled({
              feature: StandardFeature.EDIT,
              ...getPartialFeatureDefinition(item as BioentitySummary),
            })
          ) {
            return false;
          }
          // ExpandedToolbarTagEditorDropdown further filters down to models that have a
          // tagSchema, storableSchema, or schema key
          return (
            (FOLDER_ITEM_TYPES.includes(APIUtil.apiIdToType(item.id)) &&
              !APIUtil.isProcess(item.id) &&
              !APIUtil.isDataset(item.id) &&
              !APIUtil.isRequestV2Submission(item.id)) ||
            APIUtil.isProcessTask(item.id) ||
            APIUtil.isProcessOutput(item.id) ||
            APIUtil.isStorable(item.id)
          );
        },
      },
      {
        key: ActionKey.EXPORT_FOLDER_ITEMS_TO_CSV,
        isEnabled: (item: ListableItem): boolean =>
          APIUtil.isFolderItem(item.id) && isFeatureEnabled({item, feature: StandardFeature.EXPORT}),
      },
      {
        key: ActionKey.EXPORT_MOLECULES,
        isEnabled: (item: ListableItem): boolean =>
          APIUtil.isMolecule(item.id) && isFeatureEnabled({item, feature: StandardFeature.EXPORT}),
      },
      {
        key: ActionKey.EXPORT_SEQUENCES,
        isEnabled: (item: ListableItem): boolean =>
          APIUtil.apiIdToType(item.id) === ModelTypeConstants.SEQUENCE &&
          isFeatureEnabled({item, feature: StandardFeature.EXPORT}),
      },
      {
        key: ActionKey.EXPORT_PROTEINS,
        isEnabled: (item: ListableItem): boolean =>
          APIUtil.apiIdToType(item.id) === ModelTypeConstants.PROTEIN &&
          isFeatureEnabled({item, feature: StandardFeature.EXPORT}),
      },
      {
        key: ActionKey.EXPORT_ZIP,
        isEnabled: (item: ListableItem): boolean =>
          (APIUtil.isNucleotideSequence(item.id) || APIUtil.isMolecule(item.id)) &&
          isFeatureEnabled({item, feature: StandardFeature.EXPORT}),
      },
      {
        key: ActionKey.MOVE,
        isEnabled: (item: ListableItem, options: ActionOptions): boolean => {
          if (APIUtil.isFolder(item.id)) {
            const folder = item as StringIDFolder & ListableItem;
            return (folder.permissions.movable ?? false) && folder.parent != null;
          } else if (APIUtil.isFolderItem((item as StringIDFolder).api_identifier || item.id)) {
            return (
              isFeatureEnabled({
                feature: StandardFeature.MOVE,
                ...getPartialFeatureDefinition(item as BioentitySummary),
              }) &&
              (!FileUtil.isInRegistry(item) || ShortcutUtil.shouldShowShortcut(item, options.finderId))
            );
          } else if (APIUtil.isStorable(item.id)) {
            // Locations can only belong to registries.
            if (APIUtil.apiIdToType(item.id) === ModelTypeConstants.LOCATION) {
              return false;
            }
            // Wells cannot be moved out of their plates.
            if (isFixedPlateWellForNav(item)) {
              return false;
            }
            return item.permissions.writable;
          }
          return false;
        },
      },
      {
        key: ActionKey.OPEN_FILE,
        isEnabled: (item: ListableItem): boolean =>
          isFeatureEnabled({
            feature: StandardFeature.OPEN,
            ...getPartialFeatureDefinition(item as BioentitySummary),
          }) && FileStates.WORKSPACE_ITEM_TYPES.includes(APIUtil.apiIdToType(item.id)),
      },
      {
        key: ActionKey.OVERRIDE_VALIDATION,
        isEnabled: (item: ListableItem): boolean =>
          Boolean(item.schemaValidationState) &&
          isFailed(item.schemaValidationState) &&
          Boolean(item.permissions.admin),
      },
      {
        key: ActionKey.REGISTER,
        isEnabled: (item: ListableItem): boolean =>
          isFeatureEnabled({feature: RegistryFeature.REGISTRY_REGISTER, item}) &&
          APIUtil.isBiologicalEntity(item.id) &&
          !FileUtil.isInRegistry(item),
      },
      {
        key: ActionKey.SET_COLLECTION,
        isEnabled: (item: ListableItem, options: ActionOptions): boolean =>
          Boolean(
            options.isRegistry &&
              options.folder != null &&
              !(options.folder.source as RegistrySummary).disablePersonalCollections &&
              APIUtil.isBiologicalEntity(item.id)
          ),
      },
      {
        key: ActionKey.SET_TOPOLOGY,
        isEnabled: (item: ListableItem): boolean =>
          !FileUtil.isRnaSequence(item) && isEditSequenceEnabled(item),
      },
      {
        key: ActionKey.GENERATE_REPORT_FROM_ENTRIES,
        isEnabled: (item: ListableItem): boolean =>
          BenchlingConfig.STUDIES_ENABLE_EXPERIMENTAL_LLM_REPORT_GENERATION &&
          APIUtil.apiIdToType(item.id) === ModelTypeConstants.ENTRY,
      },
      {
        key: ActionKey.UNREGISTER,
        isEnabled: (item: ListableItem): boolean =>
          FileUtil.isInRegistry(item) &&
          isFeatureEnabled({feature: RegistryFeature.REGISTRY_UNREGISTER, item}),
      },
      {
        key: ActionKey.COPY_BATCH_IDS,
        isEnabled: (item: ListableItem): boolean => APIUtil.isBatch(item.id),
      },
      {
        key: ActionKey.PRINT_LABELS,
        isEnabled: (item: ListableItem): boolean =>
          isFeatureEnabled({feature: InventoryFeature.INVENTORY_EXPORT}) &&
          (APIUtil.isStorable(item.id) ||
            (APIUtil.isBiologicalEntity(item.id) && FileUtil.isInRegistry(item))),
      },
      {
        key: ActionKey.DELETE_CONTAINER_CONTENTS,
        isEnabled: (item: ListableItem): boolean =>
          APIUtil.apiIdToType(item.id) === ModelTypeConstants.CONTAINER && item.permissions.writable,
      },
      {
        key: ActionKey.COPY_BARCODES,
        isEnabled: (item: ListableItem): boolean => APIUtil.isStorable(item.id),
      },
      {
        key: ActionKey.EXPORT_CONTAINERS_TO_CSV,
        isEnabled: (item: ListableItem): boolean =>
          APIUtil.apiIdToType(item.id) === ModelTypeConstants.CONTAINER,
      },
      {
        key: ActionKey.EXPORT_PROCESSES_TO_CSV,
        isEnabled: (item: ListableItem): boolean =>
          APIUtil.apiIdToType(item.id) === ModelTypeConstants.PROCESS,
      },
      {
        key: ActionKey.EXPORT_PROCESS_TASKS_TO_CSV,
        isEnabled: (item: ListableItem): boolean =>
          APIUtil.apiIdToType(item.id) === ModelTypeConstants.PROCESS_TASK,
      },
      {
        key: ActionKey.EXPORT_REQUESTS_TO_CSV,
        isEnabled: (item: ListableItem): boolean =>
          APIUtil.apiIdToType(item.id) === ModelTypeConstants.REQUEST,
      },
      {
        key: ActionKey.MOVE_STORABLES,
        isEnabled: (item: ListableItem): boolean => APIUtil.isStorable(item.id),
      },
      {
        key: ActionKey.CREATE_REQUEST_FROM_BIOENTITIES,
        isEnabled: (item: ListableItem): boolean =>
          APIUtil.isBiologicalEntity(item.id) && Boolean(item.tagSchema),
      },
      {
        key: ActionKey.CREATE_REQUEST_FROM_CONTAINERS,
        isEnabled: (item: ListableItem): boolean => APIUtil.isContainer(item.id),
      },
      {
        key: ActionKey.UPDATE_REQUEST_STATUS,
        isEnabled: (item: ListableItem): boolean =>
          APIUtil.apiIdToType(item.id) === ModelTypeConstants.REQUEST,
      },
      {
        key: ActionKey.ADD_TO_STUDIES,
        isEnabled: (item: ListableItem) => BenchlingConfig.STUDIES_ENABLE && isItemStudyable(item),
      },
      {
        key: ActionKey.ADD_TO_WORKLIST,
        isEnabled: (item: ListableItem): boolean => WorklistUtil.apiIdHasWorklistType(item.id),
      },
      {
        key: ActionKey.REMOVE_FROM_WORKLIST,
        // We do validation later in RemoveFromWorklistButton so we can provide more specific information.
        isEnabled: (item: ListableItem): boolean => true,
      },
      {
        key: ActionKey.SAVE_ORDER,
        isEnabled: (item: ListableItem): boolean => true,
      },
      {
        key: ActionKey.EXPORT_ALIGNMENT_SOURCE_FILES,
        isEnabled: (item: ListableItem) =>
          APIUtil.apiIdToType(item.id) === ModelTypeConstants.SEQUENCE_ANALYSIS &&
          isFeatureEnabled({item, feature: StandardFeature.EXPORT}) &&
          (item as SequenceAnalysisSummaryGraphQL).attachedFileCount > 0,
      },
      {
        key: ActionKey.EXECUTE_PROCESS_TASKS,
        isEnabled: (item: ListableItem): boolean =>
          APIUtil.apiIdToType(item.id) === ModelTypeConstants.PROCESS_TASK,
      },
      {
        key: ActionKey.CREATE_PROCESS,
        isEnabled: (item: ListableItem) =>
          isFeatureEnabled({
            feature: ProcessesFeature.PROCESSES_CREATE,
          }) &&
          (APIUtil.isStorable(item.id) ||
            APIUtil.isBiologicalEntity(item.id) ||
            APIUtil.isTestOrder(item.id)),
        isAllEnabled: (items: Array<ListableItem>) =>
          // Test orders can be selected with storables b/c we extract containers referenced by test orders
          items.every((item) => APIUtil.isStorable(item.id) || APIUtil.isTestOrder(item.id)) ||
          items.every((item) => APIUtil.isBiologicalEntity(item.id)),
      },
      {
        key: ActionKey.CREATE_REQUEST_V2,
        isEnabled: (item: ListableItem) =>
          isFeatureEnabled({
            feature: V2RequestsFeature.V2_REQUESTS_CREATE,
          }) &&
          BenchlingConfig.REQUESTS_V2_ENABLE &&
          (APIUtil.isStorable(item.id) ||
            APIUtil.isBiologicalEntity(item.id) ||
            APIUtil.isTestOrder(item.id)),
        isAllEnabled: (items: Array<ListableItem>) =>
          // Test orders can be selected with storables b/c we extract containers referenced by test orders
          items.every((item) => APIUtil.isStorable(item.id) || APIUtil.isTestOrder(item.id)) ||
          items.every((item) => APIUtil.isBiologicalEntity(item.id)),
      },
    ];

    if (BenchlingConfig.MOLBIO_ENABLE_MODIFIED_NUCLEOTIDES) {
      actionConfigurations.push({
        key: ActionKey.APPLY_MOD_PATTERN,
        isEnabled: (item: ListableItem) => FileUtil.isOligo(item),
        isAllEnabled: (items: Array<ListableItem>) =>
          items.every((item) => FileUtil.isOligo(item)) &&
          new Set(items.map((item) => (item as SequenceSummary).nucleotideType)).size === 1 &&
          items.length <= MAX_NUM_BULK_EDIT_MODS_TARGETS,
        getTooltipTitle: (items: Array<ListableItem>) => {
          if (new Set(items.map((item) => (item as SequenceSummary).nucleotideType)).size > 1) {
            return 'Modification pattern can only be applied to oligos of the same nucleotide type';
          }
          if (items.length > MAX_NUM_BULK_EDIT_MODS_TARGETS) {
            return `Modification patterns can only be applied to max of ${MAX_NUM_BULK_EDIT_MODS_TARGETS} oligos`;
          }
          return '';
        },
      });
    }

    if (BenchlingConfig.MOLBIO_ENABLE_MODIFIED_NUCLEOTIDES) {
      actionConfigurations.push({
        key: ActionKey.FIND_AND_REPLACE_NUCLEOTIDES,
        isEnabled: (item: ListableItem) => isBulkFindAndReplaceEnabled([item]),
        isAllEnabled: isBulkFindAndReplaceEnabled,
        getTooltipTitle: getBulkFindAndReplaceTooltipTitle,
      });
    }

    // Available actions are calculated by the ActionConfigurations:
    // - If items are selected and the action is enabled for all selected items, the action is enabled.
    // - If the action could be enabled for any items on the page, it is visible but disabled.
    const visibleActions: Array<Action> = _.compact(
      actionConfigurations.map((actionConfig) => {
        if (!this.props.items.some((item) => actionConfig.isEnabled(item, options))) {
          return null;
        }
        // Calculate the selected items which apply to this action, since the buttons
        // only expect valid items for that action.
        const filteredSelectedItems = selectedItems.filter((item) => actionConfig.isEnabled(item, options));
        const action: Action = {
          key: actionConfig.key,
          disabled: Boolean(
            selectedItems.length === 0 ||
              !selectedItems.every((item) => actionConfig.isEnabled(item, options)) ||
              (actionConfig.isAllEnabled && !actionConfig.isAllEnabled(selectedItems, options))
          ),
          selectedIds: filteredSelectedItems.map(({id}) => id),
          selectedItems: filteredSelectedItems,
          tooltipTitle: actionConfig.getTooltipTitle?.(selectedItems, options),
        };
        return action;
      })
    );
    const actionsByKey = _.indexBy(visibleActions, 'key');
    return (
      <div className="buttonToolbar" {...getTestProps({component: 'ExpandedToolbar', element: 'root'})}>
        <div className="buttonGroup">
          {actionsByKey[ActionKey.EDIT] &&
            this.getEditorDropdown(actionsByKey[ActionKey.EDIT], selectedItems)}
          {actionsByKey[ActionKey.SET_COLLECTION] && (
            <SetCollectionModalButton
              disabled={actionsByKey[ActionKey.SET_COLLECTION].disabled}
              files={actionsByKey[ActionKey.SET_COLLECTION].selectedItems}
              onClickTracking={() => {
                this.trackBulkAction('SetRegistryCollection', ACTION_CATEGORY.WRITE);
              }}
            />
          )}
          {actionsByKey[ActionKey.REGISTER] && (
            <RegisterDropdown
              files={actionsByKey[ActionKey.REGISTER].selectedItems as Array<FileSummary>}
              disabled={actionsByKey[ActionKey.REGISTER].disabled}
              onClickTracking={(selectedItemName: string) => {
                this.trackBulkAction(`RegisterDropdown-${selectedItemName}`, ACTION_CATEGORY.WRITE);
              }}
            />
          )}
          {actionsByKey[ActionKey.UNREGISTER] && (
            <UnregisterButton
              disabled={actionsByKey[ActionKey.UNREGISTER].disabled}
              files={actionsByKey[ActionKey.UNREGISTER].selectedItems}
              finderId={this.props.finderId}
              initialSelectedFolderId={initialSelectedFolderId}
              onClickTracking={() => {
                this.trackBulkAction('Unregister', ACTION_CATEGORY.WRITE);
              }}
            />
          )}
          {actionsByKey[ActionKey.MOVE] && (
            <MoveButton
              disabled={actionsByKey[ActionKey.MOVE].disabled}
              files={actionsByKey[ActionKey.MOVE].selectedItems}
              finderId={this.props.finderId}
              initialSelectedFolderId={initialSelectedFolderId}
              onClickTracking={() => {
                this.trackBulkAction('Move', ACTION_CATEGORY.WRITE);
              }}
            />
          )}
          {actionsByKey[ActionKey.COPY] && (
            <CopyButton
              disabled={actionsByKey[ActionKey.COPY].disabled}
              files={actionsByKey[ActionKey.COPY].selectedItems}
              initialSelectedFolderId={initialSelectedFolderId}
              onClickTracking={() => {
                this.trackBulkAction('Copy', ACTION_CATEGORY.WRITE);
              }}
            />
          )}
          {actionsByKey[ActionKey.CREATE_PROCESS] && (
            <div className="buttonGroup">
              <CreateProcessButton
                buttonStyle={ButtonStyle.TERTIARY_WHITE}
                buttonSize={ButtonSize.SMALL}
                disabled={actionsByKey[ActionKey.CREATE_PROCESS].disabled}
                items={this.getSelectedItemsForTaskCreationShortcuts(
                  actionsByKey[ActionKey.CREATE_PROCESS].selectedIds,
                  actionsByKey[ActionKey.CREATE_PROCESS].selectedItems
                )}
                sourceType={this.getActionOrigin()}
                onClickTracking={() => {
                  this.trackBulkAction('CreateProcess', ACTION_CATEGORY.WRITE);
                }}
              />
            </div>
          )}
          {actionsByKey[ActionKey.CREATE_REQUEST_V2] && (
            <Tooltip title="Create request">
              <CreateRequestV2SubmissionShortcutButton
                disabled={actionsByKey[ActionKey.CREATE_REQUEST_V2].disabled}
                items={this.getSelectedItemsForTaskCreationShortcuts(
                  actionsByKey[ActionKey.CREATE_REQUEST_V2].selectedIds,
                  actionsByKey[ActionKey.CREATE_REQUEST_V2].selectedItems
                )}
                actionOrigin={this.getActionOrigin()}
              />
            </Tooltip>
          )}
          {actionsByKey[ActionKey.ARCHIVE] && (
            <ArchiveButton
              buttonStyle={ButtonStyle.TERTIARY_WHITE}
              items={actionsByKey[ActionKey.ARCHIVE].selectedItems.map((item) =>
                mapRootFolderToProject(item)
              )}
              disabled={actionsByKey[ActionKey.ARCHIVE].disabled}
              getAnalyticsMetadata={() => ({
                actionOrigin: this.getActionOrigin(),
              })}
              onArchive={
                // If archiving is disabled, we don't want to call `getArchiveAction` since it throws an
                // error when passed multiple item types that are each archivable but dont all use the same
                // action.
                actionsByKey[ActionKey.ARCHIVE].disabled
                  ? noop
                  : ArchiveActionsUtil.getArchiveAction(
                      actionsByKey[ActionKey.ARCHIVE].selectedItems.map(
                        (item) => mapRootFolderToProject(item).id
                      )
                    )
              }
              shouldDetectShortcuts={ShortcutUtil.shouldDetectShortcuts(this.props.finderId)}
              onClickTracking={() => {
                this.trackBulkAction('Archive', ACTION_CATEGORY.WRITE);
              }}
            />
          )}
          {actionsByKey[ActionKey.UNARCHIVE] && (
            <UnarchiveButton
              buttonStyle={ButtonStyle.TERTIARY_WHITE}
              itemIds={actionsByKey[ActionKey.UNARCHIVE].selectedItems.map(
                (item) => mapRootFolderToProject(item).id
              )}
              unarchiveOptions={{
                hasRegisteredItems: actionsByKey[ActionKey.UNARCHIVE].selectedItems.some(
                  (item) => APIUtil.isBiologicalEntity(item.id) && FileUtil.isInRegistry(item)
                ),
              }}
              disabled={actionsByKey[ActionKey.UNARCHIVE].disabled}
              getAnalyticsMetadata={() => ({
                actionOrigin: this.getActionOrigin(),
              })}
              onUnarchive={
                // If unarchiving is disabled, we don't want to call `getUnarchiveAction` since it throws an
                // error when passed multiple item types that are each unarchivable but dont all use the same
                // action.
                actionsByKey[ActionKey.UNARCHIVE].disabled
                  ? noop
                  : ArchiveActionsUtil.getUnarchiveAction(
                      actionsByKey[ActionKey.UNARCHIVE].selectedItems.map(
                        (item) => mapRootFolderToProject(item).id
                      )
                    )
              }
              onClickTracking={() => {
                this.trackBulkAction('Unarchive', ACTION_CATEGORY.WRITE);
              }}
            />
          )}
          {actionsByKey[ActionKey.DELETE] && (
            <DeleteButton
              files={actionsByKey[ActionKey.DELETE].selectedItems}
              disabled={actionsByKey[ActionKey.DELETE].disabled}
              finderId={this.props.finderId}
              onClickTracking={() => {
                this.trackBulkAction('Delete', ACTION_CATEGORY.WRITE);
              }}
            />
          )}
          {actionsByKey[ActionKey.UPDATE_REQUEST_STATUS] && (
            <RequestStatusDropdown
              isDisabled={actionsByKey[ActionKey.UPDATE_REQUEST_STATUS].disabled}
              buttonStyle={ButtonStyle.TERTIARY_WHITE}
              onUpdateRequestStatus={(newStatus: string) => {
                this.trackBulkAction(`UpdateRequestStatus-${newStatus}`, ACTION_CATEGORY.WRITE);
                this.props.onBulkUpdateRequests(
                  actionsByKey[ActionKey.UPDATE_REQUEST_STATUS].selectedItems.map(({id}) => id),
                  {
                    requestStatus: newStatus,
                  }
                );
              }}
            />
          )}
          {actionsByKey[ActionKey.CHECK_IN_CHECK_OUT] && (
            <CICODropdown
              actionSource={this.getActionOrigin()}
              buttonStyle={ButtonStyle.TERTIARY_WHITE}
              items={selectedItems as Array<SampleStatusItemForValidation>}
              onClickTracking={(selectedItemName: string) => {
                this.trackBulkAction(`CICODropdown-${selectedItemName}`, ACTION_CATEGORY.WRITE);
              }}
            />
          )}
          {actionsByKey[ActionKey.MOVE_STORABLES] && (
            <MoveStorablesButton
              buttonStyle={ButtonStyle.TERTIARY_WHITE}
              forceDisabled={actionsByKey[ActionKey.MOVE_STORABLES].disabled}
              customTooltipText="Move to location: Please select only inventory items"
              storables={
                actionsByKey[ActionKey.MOVE_STORABLES].selectedItems as Array<StorableWithPermissions>
              }
              onClickTracking={() => {
                this.trackBulkAction('MoveStorables', ACTION_CATEGORY.WRITE);
              }}
            />
          )}
          {actionsByKey[ActionKey.DELETE_CONTAINER_CONTENTS] && (
            <DeleteContainerContentsButton
              buttonStyle={ButtonStyle.TERTIARY_WHITE}
              disabled={actionsByKey[ActionKey.DELETE_CONTAINER_CONTENTS].disabled}
              containerIds={actionsByKey[ActionKey.DELETE_CONTAINER_CONTENTS].selectedIds}
              actionOrigin={this.getActionOrigin()}
              onClickTracking={() => {
                this.trackBulkAction('DeleteContainerContents', ACTION_CATEGORY.WRITE);
              }}
            />
          )}
          {actionsByKey[ActionKey.PRINT_LABELS] && (
            <PrintLabelButton
              buttonStyle={ButtonStyle.TERTIARY_WHITE}
              disabled={actionsByKey[ActionKey.PRINT_LABELS].disabled}
              itemIds={actionsByKey[ActionKey.PRINT_LABELS].selectedIds}
              onClickTracking={() => {
                this.trackBulkAction('PrintLabel', ACTION_CATEGORY.READ);
              }}
            />
          )}
          {BenchlingConfig.ENABLE_REQUESTS && actionsByKey[ActionKey.CREATE_REQUEST_FROM_BIOENTITIES] && (
            <CreateRequestFromSamplesButton
              buttonStyle={ButtonStyle.TERTIARY_WHITE}
              samples={getSampleDetailsForBioentities(
                actionsByKey[ActionKey.CREATE_REQUEST_FROM_BIOENTITIES]
                  .selectedItems as Array<BioentitySummary>
              )}
              size={ButtonSize.SMALL}
              onClickTracking={() => {
                this.trackBulkAction('CreateRequestFromBioentities', ACTION_CATEGORY.WRITE);
              }}
            />
          )}
          {BenchlingConfig.ENABLE_REQUESTS && actionsByKey[ActionKey.CREATE_REQUEST_FROM_CONTAINERS] && (
            <CreateRequestFromSamplesButton
              buttonStyle={ButtonStyle.TERTIARY_WHITE}
              sampleInfos={actionsByKey[ActionKey.CREATE_REQUEST_FROM_CONTAINERS].selectedIds.map(
                (sampleId) => ({
                  idForLookup: sampleId,
                })
              )}
              size={ButtonSize.SMALL}
              onClickTracking={() => {
                this.trackBulkAction('CreateRequestFromContainers', ACTION_CATEGORY.WRITE);
              }}
            />
          )}
          {BenchlingConfig.STUDIES_ENABLE && actionsByKey[ActionKey.ADD_TO_STUDIES] && (
            <AddToStudiesButton
              disabled={actionsByKey[ActionKey.ADD_TO_STUDIES].disabled}
              buttonStyle={ButtonStyle.TERTIARY_WHITE}
              itemIds={actionsByKey[ActionKey.ADD_TO_STUDIES].selectedIds}
            />
          )}
          {BenchlingConfig.WORKLISTS_ENABLE_WORKLISTS && actionsByKey[ActionKey.ADD_TO_WORKLIST] && (
            <AddToWorklistButton
              buttonStyle={ButtonStyle.TERTIARY_WHITE}
              ids={this.getSelectedItemIdsForWorklist()}
              refreshOptions={{refreshRecentWorklists: true}}
              onClickTracking={() => {
                this.trackBulkAction('AddToWorklist', ACTION_CATEGORY.WRITE);
              }}
            />
          )}
          {BenchlingConfig.WORKLISTS_ENABLE_WORKLISTS &&
            actionsByKey[ActionKey.REMOVE_FROM_WORKLIST] &&
            this.props.worklistSummary && (
              <RemoveFromWorklistButton
                disabled={actionsByKey[ActionKey.REMOVE_FROM_WORKLIST].disabled}
                ids={actionsByKey[ActionKey.REMOVE_FROM_WORKLIST].selectedIds}
                worklist={this.props.worklistSummary}
                refreshOptions={{refreshWorklistItemsSearch: true, refreshRecentWorklists: true}}
                onClickTracking={() => {
                  this.trackBulkAction('RemoveFromWorklist', ACTION_CATEGORY.WRITE);
                }}
              />
            )}
          {actionsByKey[ActionKey.EXPORT_MENU] && (
            <ExportDropdown
              // The export menu has an option to export all items, so don't disable when nothing is selected
              disabled={this.props.selectedIds.length > 0 && actionsByKey[ActionKey.EXPORT_MENU].disabled}
              buttonStyle={ButtonStyle.TERTIARY_WHITE}
              menuItems={this.getExportMenuItems(actionsByKey)}
            />
          )}
          <div
            className="buttonGroup"
            {...getTestProps({component: 'ExpandedToolbar', element: 'moreButton'})}
          >
            <Button
              buttonStyle={ButtonStyle.TERTIARY_WHITE}
              text="More"
              isDropdown={true}
              size={ButtonSize.SMALL}
            />
            <LegacyDropdownMenu
              className="dropdown-menu--dropLeft"
              items={this.getMoreMenuItems(actionsByKey)}
              dataTestAttrs={{component: 'ExpandedToolbar', element: 'moreDropdownMenu'}}
            />
          </div>
        </div>
      </div>
    );
  }
}

export default ExpandedToolbarConnector.connect(ExpandedToolbar);
